webpackJsonp([1],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var urlGlobal = "https://admin.dino-toys.com/api" + "/login";
var authorization = Object({"NODE_ENV":"production","DINO":Object({"AUTHORIZATION":"Authorization","ENDPOINT":"https://admin.dino-toys.com/api","PATH":Object({"LOGIN":"/login","GET_PRODUCTS":"secure/products","DOMWLOAD_PRODUCTS":"secure/products/excel","GET_CATEGORIES":"secure/categories","GET_BRANDS":"secure/brands","GET_COLORS":"secure/colors","GET_SIZES":"secure/sizes","PRODUCT_SAVE_PUT":"secure/product","GET_PRODUCT_COLORS":"secure/product/color/:product_id","SAVE_PRODUCT_COLOR":"secure/product/color","GET_PRODUCT_COLOR_IMAGES":"secure/product/color/images/:product_id","SAVE_PRODUCT_COLOR_IMAGES":"secure/product-color-images","SAVE_ORDER_PRODUCT_COLOR_IMAGES":"secure/product-color-images/order","GET_PRODUCT_COLOR_SIZES":"secure/product-color-sizes/:product_id","SAVE_PRODUCT_COLOR_SIZE":"secure/product/color/size","GET_ORDERS":"secure/orders","UPDATE_STATUS_ORDER":"secure/order","GET_CLIENT":"secure/client/:client_id","GET_ADDRESS":"secure/address/:address_id","GET_ORDER_SUPPLIER":"secure/order-supplier","SAVE_ORDER_SUPPLIER":"secure/order-supplier","UPDATE_STATUS_ORDER_SUPPLIER":"secure/order-supplier","GET_INVENTORIES":"secure/inventories","DOMWLOAD_INVENTORIES":"secure/inventories/excel","GET_ORDER_PROFIT":"secure/order-profit","DOMWLOAD_ORDER_PROFIT":"secure/order-profit/excel","SAVE_BANNER_HEADER":"secure/banner/header","SAVE_BANNER_BODY":"secure/banner/body","SAVE_BANNER_FOOTER":"secure/banner/footer","GET_BANNERS":"/secure/banners","UPDATE_BANNER_STATUS":"/secure/banner/status","MONTHLY_SALES_LISTS":"/secure/order/monthly-sales/:year","GET_PRODUCTS_SEARCH":"/secure/product/search?q=","GET_BEST_SELLING_PRODUCTS":"/secure/order/best-selling-products/:top","UPDATE_DELIVERY_PARTNER":"secure/order/delivery-partner","GET_DELIVERIES":"/secure/deliveries","SEARCH_CLIENT":"/secure/client?q=","GET_PRODUCT_COLOR_IMAGES_FOR_TYPE_AND_COLOR":"secure/product/color/:product_color_id/images/:type","SAVE_PARTIAL_ORDER":"/secure/partial-order","GET_RECEIVABLE":"/secure/receivable?status=:status&showCreatedOrders=:showCreatedOrders","FIND_RECEIVABLE":"/secure/receivable/:id","FIND_RECEIVABLE_DETAIL":"/secure/receivable/:receivableId/detail","SAVE_PARTIAL_PAYMENT":"/secure/receivable/payment","DELETE_RECEIVABLE_DETAIL":"/secure/receivable/detail/:id","GENERATE_ORDER":"/secure/order/save","UPDATE_PARTIAL_ORDER":"/secure/partial-order/update","DELETE_PARTIAL_ORDER_DETAIL_BY_ID":"/secure/partial-order/detail/delete","RECEIVABLE_CANCEL":"/secure/receivable/cancel","GET_DELIVERIES_CALENDAR":"/secure/deliveries/calendar","ADD_PRODUCTO_TO_PARTIAL_ORDER":"/secure/partial-order/add/product","GENERATE_TICKET":"/secure/ticket","DOMWLOAD_STOCK_PRODUCT":"secure/product/color/size/stock","MONTHLY_SALES_AND_PARTIAL_SALES_LISTS":"/secure/order/monthly/sales/partial-sales/:year","DOMWLOAD_LABELS":"/secure/labeled/motorized/deliveries","DOMWLOAD_LABELS_FOR_AGENCY":"/secure/labeled/agency/deliveries","GET_BEST_SELLING_PRODUCTS_PER_MONTH":"/secure/produts/best-selling?year=:year&month=:month&top=:top"})})}).AUTHORIZATION;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginView',
  data: function data() {
    return {
      email: '',
      password: '',
      form: false,
      rules: {
        email: function email(v) {
          return (/.+@.+\..+/.test(v) || 'Por favor ingresar un correo válido'
          );
        },
        length: function length(len) {
          return function (v) {
            return (v || '').length >= len || 'Invalid character length, required ' + len;
          };
        },
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },

      items: [{ text: 'Facebook', icon: 'mdi-facebook', color: 'blue darken-2' }, { text: 'Google', icon: 'mdi-google', color: 'red darken-2' }],
      typeSocial: null,
      tokenId: null,
      objLogin: {
        correo: null
      },
      usuario: {},
      group: null,
      infoTrabajador: [],
      contratoSelected: null,
      iContrato: null
    };
  },

  mounted: function mounted() {
    console.log('%cSí, porque toma la identidad de otra persona con el fin de perjudicarle material o moralmente, por lo que está tipificado en el Artículo 9 de la Ley Nº 30096 o Ley de delitos informáticos. La suplantación de identidad se sanciona con pena privativa de libertad no menor de tres ni mayor de cinco años.', 'background: #ffcc00; color: #000000; font-size: 13px;');
    console.log('%cYes, because it assumes the identity of another person in order to harm them materially or morally, for which it is typified in Article 9 of Law No. 30096 or Computer Crime Law. Identity theft is punishable by imprisonment for not less than three nor more than five years.', 'background: #ffcc00; color: #000000; font-size: 13px;');
  },
  methods: {
    setUsuario: function setUsuario(givenName, familyName, picture, email) {
      this.usuario.givenName = givenName;
      this.usuario.familyName = familyName;
      this.usuario.picture = picture;
      this.usuario.correo = email;
    },

    login: function login() {
      var _this = this;

      var request = {
        email: this.email,
        password: this.password
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(urlGlobal, request).then(function (response) {
        if (response.data.success) {
          localStorage.clear();
          localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user));
          localStorage.setItem('menus', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.menus));
          localStorage.setItem('authorization', response.data.authorization);
          _this.redirect();
        } else {
          alert(response.data.message);
          _this.logout();
        }
      }).catch(function (err) {
        alert(err.message);
        console.log(err.response);
        _this.logout();
      });
    },

    redirect: function redirect() {
      this.$router.push({ name: 'Inicio' }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InicioView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },


    logout: function logout() {
      localStorage.clear();
      window.location.href = "/";
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };
  }
});

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DefaultLayout',
  data: function data() {
    return {
      drawer: true,
      group: null,

      usuario: {},
      menus: [],
      account: null,
      authorization: null,
      infoTrabajador: {},

      installer: undefined
    };
  },
  created: function created() {
    var installPrompt = void 0;

    window.addEventListener("beforeinstallprompt", function (e) {
      e.preventDefault();
      installPrompt = e;
    });

    this.installer = function () {
      installPrompt.prompt();
      installPrompt.userChoice.then(function (result) {
        if (result.outcome === "accepted") {
          console.log("User accepted");
        } else {
          console.log("User denied");
        }
        installPrompt = null;
      });
    };
  },

  mounted: function mounted() {
    this.usuario = JSON.parse(localStorage.getItem('user'));
    this.menus = JSON.parse(localStorage.getItem('menus'));
    this.authorization = localStorage.getItem('authorization');

    if (this.authorization == null || this.authorization == '') {
      this.logout();
    }
  },
  watch: {
    group: function group() {
      this.drawer = true;
    }
  },
  methods: {
    logout: function logout() {
      localStorage.clear();
      window.location.href = "/";
    }
  }
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highcharts_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__["a" /* default */],
    highcharts: __WEBPACK_IMPORTED_MODULE_3_highcharts_vue__["Chart"]
  },
  data: function data() {
    return {
      overlay: false,
      panel: [0, 1, 2, 3],
      year: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY"),
      yearForSaleAndPartialSale: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY"),
      top: 5,
      topD4: 10,
      monthD4: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("MM"),
      yearD4: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY"),
      select: {
        year: [{ id: '2021', name: '2021' }, { id: '2022', name: '2022' }, { id: '2023', name: '2023' }, { id: '2024', name: '2024' }, { id: '2025', name: '2025' }, { id: '2026', name: '2026' }],
        top: [{ id: 5, name: '5' }, { id: 10, name: '10' }, { id: 15, name: '15' }, { id: 20, name: '20' }],
        month: [{ id: '01', name: 'ENERO' }, { id: '02', name: 'FEBRERO' }, { id: '03', name: 'MARZO' }, { id: '04', name: 'ABRIL' }, { id: '05', name: 'MAYO' }, { id: '06', name: 'JUNIO' }, { id: '07', name: 'JULIO' }, { id: '08', name: 'AGOSTO' }, { id: '09', name: 'SEPTIEMBRE' }, { id: '10', name: 'OCTUBRE' }, { id: '11', name: 'NOVIEMBRE' }, { id: '12', name: 'DICIEMBRE' }]
      },
      date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().toISOString().substr(0, 10),
      hoy: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("DD MMMM YYYY"),
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'VENTAS DEL AÑO'
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'total ventas en S/.'
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: 'S/.{point.y:.1f}'
            }
          }
        },
        series: [{
          name: 'Ventas',
          colorByPoint: true,
          data: []
        }]
      },
      chartOptionsForSaleAndPartialSale: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'VENTAS + BOLSITAS SIN CERRAR<br>DEL AÑO'
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'total ventas en S/.'
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: 'S/.{point.y:.1f}'
            }
          }
        },
        series: [{
          name: 'Ventas',
          colorByPoint: true,
          data: []
        }]
      },
      lineChartOptions: {
        chart: {
          type: 'line'
        },
        title: {
          text: 'Productos con más ventas',
          align: 'left'
        },

        subtitle: {
          text: 'Visualizar: <a href="https://admin.dino-toys.com/#/manage/product" target="_blank">PRODUCTOS</a>.',
          align: 'left'
        },

        yAxis: {
          title: {
            text: 'Cantidad vendida'
          }
        },

        xAxis: {
          categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          accessibility: {
            description: 'Months of the year'
          }
        },

        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },

        tooltip: {
          crosshairs: true,
          shared: true
        },

        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1
            }
          }
        },

        series: [],

        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }]
        }
      },
      chartOptionsBestSellingProductsPerMonth: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'VENTAS DEL AÑO'
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'unidades'
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y}'
            }
          }
        },
        series: [{
          name: 'Ventas',
          colorByPoint: true,
          data: []
        }]
      },
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },


    getMonthlySales: function getMonthlySales() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/secure/order/monthly-sales/:year".replace(':year', this.year)).then(function (response) {
        var list = [];
        response.data.forEach(function (value, index) {
          list.push({ 'y': value.total, 'name': __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.created_at).format("MMMM") });
        });
        _this.chartOptions.series[0].data = list;
      }).catch(function (error) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },

    getMonthlySalesAndPartialSales: function getMonthlySalesAndPartialSales() {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/secure/order/monthly/sales/partial-sales/:year".replace(':year', this.year)).then(function (response) {
        var list = [];
        response.data.forEach(function (value, index) {
          list.push({ 'y': value.total, 'name': __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.created_at).format("MMMM") });
        });
        _this2.chartOptionsForSaleAndPartialSale.series[0].data = list;
      }).catch(function (error) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    },

    getBestSellingProducts: function getBestSellingProducts() {
      var _this3 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/secure/order/best-selling-products/:top".replace(':top', this.top)).then(function (response) {
        _this3.lineChartOptions.series = response.data;
      }).catch(function (error) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this3.overlay = false;
      });
    },

    bestSellingProductsPerMonth: function bestSellingProductsPerMonth() {
      var _this4 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/secure/produts/best-selling?year=:year&month=:month&top=:top".replace(':year', this.yearD4).replace(':month', this.monthD4).replace(':top', this.topD4)).then(function (response) {
        var list = [];
        response.data.forEach(function (value, index) {
          list.push({
            'y': Number(value['order_detail.quantity_units_product']),
            'name': value['order_detail.product.name']
          });
        });

        _this4.chartOptionsBestSellingProductsPerMonth.series[0].data = list;
      }).catch(function (error) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this4.overlay = false;
      });
    },

    logout: function logout() {
      localStorage.clear();
      window.location.href = "/";
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getMonthlySales();
    this.getBestSellingProducts();
    this.getMonthlySalesAndPartialSales();
    this.bestSellingProductsPerMonth();
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_4__layouts_DefaultLayout__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a
  },
  data: function data() {
    return {
      overlay: false,
      dialog: false,
      tab: null,
      panel: [1],
      active: null,
      modal: false,
      dates: [__WEBPACK_IMPORTED_MODULE_6_moment___default()().toISOString().substr(0, 10), __WEBPACK_IMPORTED_MODULE_6_moment___default()().toISOString().substr(0, 10)],
      date: __WEBPACK_IMPORTED_MODULE_6_moment___default()().toISOString().substr(0, 10),
      searchProduct: {
        startDate: null,
        endDate: null
      },
      search: '',
      headers: [{ text: 'MARCA', value: 'brand.name' }, { text: 'GRUPO', value: 'group' }, { text: 'PRODUCTO', value: 'name' }, { text: 'P. VENTA', value: 'regular_price' }, { text: 'DESCUENTO (%)', value: 'off' }, { text: 'P. C/ DESCUENTO', value: 'sale_price' }, { text: 'TAMAÑO', value: 'size_delivery' }, { text: 'ESTADO', value: 'status' }, { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }],
      items: [],
      valid: true,
      validProductColor: true,
      validProductColorImage: true,
      validProductColorSize: true,
      rules: {
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },
      select: {
        categories: [],
        brands: [],
        colors: [],
        sizes: [],
        groups: [{ id: 'HOT WHEELS', name: 'HOT WHEELS' }, { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' }, { id: 'MINECRAFT', name: 'MINECRAFT' }, { id: 'JUEGOS DE MESA', name: 'JUEGOS DE MESA' }, { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' }, { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' }, { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' }, { id: 'BLAZE', name: 'BLAZE' }, { id: 'SMASHERS', name: 'SMASHERS' }, { id: 'MUÑECAS', name: 'MUÑECAS' }, { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' }, { id: 'NERF', name: 'NERF' }, { id: 'PLAY DOH', name: 'PLAY DOH' }, { id: 'SUPER MARIO', name: 'SUPER MARIO' }, { id: 'PRINCESAS', name: 'PRINCESAS' }, { id: 'FRIEND', name: 'FRIEND' }, { id: 'MUNDO BEBE', name: 'MUNDO BEBE' }, { id: 'DIDACTICOS', name: 'DIDACTICOS' }, { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' }, { id: 'ÚTILES', name: 'ÚTILES' }, { id: 'PELUCHES INTERACTIVOS', name: 'PELUCHES INTERACTIVOS' }, { id: 'MAQUILLAJE', name: 'MAQUILLAJE' }, { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' }, { id: 'NAVIDAD', name: 'NAVIDAD' }, { id: 'BLUEY', name: 'BLUEY' }],
        size_deliveries: [{ id: 1, name: 'PEQUEÑO' }, { id: 2, name: 'MEDIANO' }, { id: 3, name: 'GRANDE' }],
        status: [{ id: 1, name: 'ACTIVO' }, { id: 2, name: 'INACTIVO' }]
      },
      product: {
        id: null,
        brand_id: null,
        category_id: null,
        name: null,
        description: null,
        average_star: null,
        off: null,
        regular_price: null,
        sale_price: null,
        size_delivery: null,
        group: null,
        status: null
      },
      PCHeaders: [{ text: 'COLOR', value: 'color.name', width: '60%' }, { text: 'ESTADO', value: 'status', width: '20%' }, { text: 'ACCIONES', value: 'actions', width: '20%', filterable: false, sortable: false }],
      PCItems: [],
      product_color: {
        id: null,
        product_id: null,
        color_id: null,
        status: null
      },
      PCIItems: [],
      imagesRefactor: [],
      product_color_image: {
        id: null,
        product_color_id: null,
        images: [],
        status: null
      },
      imagesTmp: [],
      PCSHeaders: [{ text: 'COLOR', value: 'product_color.color.name', width: '20%' }, { text: 'TALLA', value: 'size.name', width: '20%' }, { text: 'STOCK', value: 'stock', width: '20%' }, { text: 'ESTADO', value: 'status', width: '20%' }, { text: 'ACCIONES', value: 'actions', width: '20%', filterable: false, sortable: false }],
      PCSItems: [],
      product_color_size: {
        id: null,
        product_color_id: null,
        size_id: null,
        stock: null,
        status: null
      },
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  computed: {
    dateRangeText: function dateRangeText() {
      var newDate = [];
      newDate[0] = this.formatDate(this.dates[0]);
      newDate[1] = this.formatDate(this.dates[1]);

      if (newDate[1]) {
        if (this.dates[1] < this.dates[0]) {
          var newStartDateOld = newDate[1];
          var newEndDateOld = newDate[0];
          newDate[0] = newStartDateOld;
          newDate[1] = newEndDateOld;
        }
      }

      if (newDate[0] && !newDate[1]) {
        newDate[1] = newDate[0];
      }

      var _newDate$0$split = newDate[0].split('/'),
          _newDate$0$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_newDate$0$split, 3),
          day = _newDate$0$split2[0],
          month = _newDate$0$split2[1],
          year = _newDate$0$split2[2];

      var start = year + '-' + month + '-' + day;

      var _newDate$1$split = newDate[1].split('/'),
          _newDate$1$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_newDate$1$split, 3),
          day2 = _newDate$1$split2[0],
          month2 = _newDate$1$split2[1],
          year2 = _newDate$1$split2[2];

      var end = year2 + '-' + month2 + '-' + day2;

      this.searchProduct.startDate = start;
      this.searchProduct.endDate = end;

      if (end) {
        if (end < start) {
          this.searchProduct.startDate = end;
          this.searchProduct.endDate = start;
        }
      }

      return newDate.join(' - ');
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    getProducts: function getProducts() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/products", {
        params: {
          startDate: this.searchProduct.startDate,
          endDate: this.searchProduct.endDate
        }
      }).then(function (response) {
        _this.items = response.data;
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },
    domwloadExcel: function domwloadExcel() {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/products/excel", {
        responseType: 'blob',
        headers: {
          'Content-Type': 'text/csv'
        },
        params: {
          startDate: this.searchProduct.startDate,
          endDate: this.searchProduct.endDate
        }
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    },
    getCategories: function getCategories() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/categories").then(function (response) {
        _this3.select.categories = response.data;
      }).catch(function (err) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      });
    },
    getBrands: function getBrands() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/brands").then(function (response) {
        _this4.select.brands = response.data;
      }).catch(function (err) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      });
    },
    getColors: function getColors() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/colors").then(function (response) {
        _this5.select.colors = response.data;
      }).catch(function (err) {
        _this5.showMessage('Hubo un problema en el servidor', 'red');
      });
    },
    getSizes: function getSizes() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/sizes").then(function (response) {
        _this6.select.sizes = response.data;
      }).catch(function (err) {
        _this6.showMessage('Hubo un problema en el servidor', 'red');
      });
    },
    getColorOrTextStatus: function getColorOrTextStatus(status, type) {
      var value = '';

      if (type === 'color') {
        value = status == 1 ? 'green' : 'red';
      } else if (type === 'text') {
        value = status == 1 ? 'ACTIVO' : 'INACTIVO';
      }

      return value;
    },
    cleanForm: function cleanForm() {
      this.product.id = null;
      this.product.average_star = null;
      this.product.description = null;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    cleanFormProductColor: function cleanFormProductColor() {
      this.product_color.id = null;
      this.product_color.color_id = null;
      this.product_color.status = null;
      if (!this.dialog) {
        this.product_color.product_id = null;
        this.PCItems = [];
        // this.$refs.formProductColor.reset();
        // this.$refs.formProductColor.resetValidation();
      }
    },
    cleanFormProductColorImage: function cleanFormProductColorImage() {
      this.product_color_image.id = null;
      this.product_color_image.status = null;
      this.product_color_image.product_color_id = null;
      this.imagesTmp = [];
      if (!this.dialog) {
        this.product_color_image.images = [];
        this.imagesRefactor = [];
        this.PCIItems = [];
        // this.$refs.formProductColorImage.reset();
        // this.$refs.formProductColorImage.resetValidation();
      }
    },
    cleanFormProductColorSize: function cleanFormProductColorSize() {
      this.product_color_size.id = null;
      this.product_color_size.product_color_id = null;
      this.product_color_size.size_id = null;
      this.product_color_size.stock = null;
      this.product_color_size.status = null;
      if (!this.dialog) {
        this.product_color.product_id = null;
        this.PCSItems = [];
        // this.$refs.formProductColorSize.reset();
        // this.$refs.formProductColorSize.resetValidation();
      }
    },
    showDetail: function showDetail(item) {
      this.product.id = item.id;
      this.product.brand_id = item.brand.id;
      this.product.category_id = item.category_id;
      this.product.name = item.name;
      this.product.description = item.description;
      this.product.average_star = item.average_star;
      this.product.off = item.off;
      this.product.regular_price = item.regular_price;
      this.product.sale_price = item.sale_price;
      this.product.size_delivery = item.size_delivery;
      this.product.group = item.group;
      this.product.status = item.status;
      this.product_color.product_id = item.id;

      this.dialog = true;
      this.getProductColors();
      this.getProductColorImages();
      this.getProductColorSizes();
    },
    submitProduct: function submitProduct() {
      var _this7 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put("secure/product", this.product).then(function (response) {
        _this7.product.id = response.data.product_id;
        _this7.product_color.product_id = response.data.product_id;
        _this7.getProducts();
        _this7.showMessage(response.data.message, 'green');
      }).catch(function (err) {
        _this7.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this7.overlay = false;
      });
    },
    getProductColors: function getProductColors() {
      var _this8 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/product/color/:product_id".replace(':product_id', this.product.id)).then(function (response) {
        _this8.PCItems = response.data;
      }).catch(function (err) {
        _this8.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this8.overlay = false;
      });
    },
    showDetailProductColor: function showDetailProductColor(item) {
      this.product_color.id = item.id;
      this.product_color.color_id = item.color_id;
      this.product_color.product_id = item.product_id;
      this.product_color.status = item.status;
    },
    submitProductColor: function submitProductColor() {
      var _this9 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put("secure/product/color", this.product_color).then(function (response) {
        _this9.$refs.formProductColor.reset();
        _this9.showMessage(response.data.message, 'green');
      }).then(function () {
        _this9.cleanFormProductColor();
        _this9.getProductColors();
      }).catch(function (err) {
        _this9.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this9.overlay = false;
      });
    },
    getProductColorImages: function getProductColorImages() {
      var _this10 = this;

      this.overlay = true;
      var storage = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.storage();
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/product/color/images/:product_id".replace(':product_id', this.product.id)).then(function (response) {
        _this10.PCIItems = response.data;
      }).then(function () {
        var imagesRefactor = [];
        _this10.PCIItems.map(function (pcii) {

          var images = [];
          pcii.product_color_image.map(function (image) {
            images.push({ id: image.id, product_color_id: image.product_color_id, image: image.image, order: image.order });
          });

          imagesRefactor.push({
            color_id: pcii.color_id,
            update_position: false,
            status: pcii.status,
            images: images
          });
        });

        _this10.imagesRefactor = imagesRefactor;
      }).catch(function (err) {
        _this10.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this10.overlay = false;
      });
    },
    saveProductColorImages: function saveProductColorImages() {
      var _this11 = this;

      this.overlay = true;

      var form = new FormData();
      this.imagesTmp.forEach(function (file, index) {
        form.append('files', file, file.name);
      });

      form.append('id', this.product_color_image.id);
      form.append('product_color_id', this.product_color_image.product_color_id);
      form.append('images', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.product_color_image.images));
      form.append('status', this.product_color_image.status);

      var config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      };

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("secure/product-color-images", form, config).then(function (response) {
        _this11.showMessage(response.data.message, 'green');
      }).then(function () {
        _this11.onUpload();
      }).then(function () {
        _this11.$refs.formProductColorImage.reset();
        _this11.cleanFormProductColorImage();
        _this11.getProductColorImages();
      }).catch(function (err) {
        _this11.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this11.overlay = false;
      });
    },
    onUpload: function onUpload() {
      /*
      * Upload images to Firebease Storage is for type 'grande'
      * the images type 'chico' is upload in backend
      */
      var storage = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.storage();
      var metadata = {
        cacheControl: "public, max-age=31536000"
      };

      this.imagesTmp.map(function (file, index) {
        var task = storage.ref('/img/products/872x872/' + file.name).put(file, metadata);
      });
    },
    imagesSelected: function imagesSelected() {
      var _this12 = this;

      var domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
      var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!this.imagesTmp || !this.imagesTmp.length) return;

      var promises = this.imagesTmp.map(function (file) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          // Validar tipo
          if (!allowedTypes.includes(file.type)) {
            _this12.showMessage('Tipo de imagen inv\xE1lido, solo se acepta JPEG, JPG o PNG: ' + file.name, 'deep-purple accent-4');
            console.log('Tipo de imagen inv\xE1lido: ' + file.name);
            reject(new Error('Tipo inv\xE1lido: ' + file.name));
            return;
          }

          var reader = new FileReader();
          reader.onload = function (e) {
            var imgEl = new Image();
            imgEl.onload = function () {
              // Validar dimensiones
              if (imgEl.width !== 872 || imgEl.height !== 872) {
                _this12.showMessage('Dimensiones inv\xE1lidas, solo se acepta 872x872: ' + file.name + ' (' + imgEl.width + 'x' + imgEl.height + ')', 'deep-purple accent-4');
                console.log('Dimensiones inv\xE1lidas: ' + file.name + ' (' + imgEl.width + 'x' + imgEl.height + ')');
                reject(new Error('Dimensiones inv\xE1lidas: ' + file.name));
              } else {
                resolve(file);
              }
            };
            imgEl.src = e.target.result;
          };
          reader.readAsDataURL(file);
        });
      });

      // Ejecutar todas las validaciones
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (validFiles) {
        // Todas las imágenes son válidas, generamos URLs
        var img = [];

        validFiles.forEach(function (file, index) {
          var order = index + 1;

          // GRANDE
          var image = encodeURIComponent('/products/872x872/' + file.name);
          img.push({
            image: domain.concat(image + '?alt=media'),
            order: order,
            type: 'grande',
            name: file.name
          });

          // MEDIANO (solo la primera imagen)
          if (index === 0) {
            image = encodeURIComponent('/products/300x300/' + file.name);
            img.push({
              image: domain.concat(image + '?alt=media'),
              order: order,
              type: 'mediano',
              name: file.name
            });
          }

          // CHICO
          image = encodeURIComponent('/products/100x100/' + file.name);
          img.push({
            image: domain.concat(image + '?alt=media'),
            order: order,
            type: 'chico',
            name: file.name
          });
        });

        // Guardamos solo imágenes válidas
        _this12.imagesTmp = validFiles;
        _this12.product_color_image.images = img;
      }).catch(function (err) {
        // Al menos una imagen falló → cancelar toda la selección
        _this12.imagesTmp = [];
        _this12.product_color_image.images = [];
      });
    },
    imagesSelectedOld: function imagesSelectedOld() {
      var domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
      var img = [];
      this.imagesTmp.map(function (file, index) {
        var order = index + 1;

        var image = encodeURIComponent('/products/872x872/' + file.name);
        image = domain.concat(image + '?alt=media');
        img.push({ image: image, order: order, type: 'grande', name: file.name });

        if (index == 0) {
          image = encodeURIComponent('/products/300x300/' + file.name);
          image = domain.concat(image + '?alt=media');
          img.push({ image: image, order: order, type: 'mediano', name: file.name });
        }

        image = encodeURIComponent('/products/100x100/' + file.name);
        image = domain.concat(image + '?alt=media');
        img.push({ image: image, order: order, type: 'chico', name: file.name });
      });

      this.product_color_image.images = img;
    },
    updateOrderImg: function updateOrderImg(color) {
      var _this13 = this;

      this.overlay = true;

      var img = [];
      color.images.map(function (image, index) {
        var order = index + 1;
        img.push({ product_color_id: image.product_color_id, image: image.image, order: order, type: 'grande', status: color.status });
        if (index == 0) {
          img.push({ product_color_id: image.product_color_id, image: image.image.replace('872x872', '300x300'), order: order, type: 'mediano', status: color.status });
        }
        img.push({ product_color_id: image.product_color_id, image: image.image.replace('872x872', '100x100'), order: order, type: 'chico', status: color.status });
      });

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put("secure/product-color-images/order", img).then(function (response) {
        _this13.showMessage(response.data.message, 'green');
      }).then(function () {
        _this13.cleanFormProductColorImage();
        _this13.getProductColorImages();
      }).catch(function (err) {
        _this13.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this13.overlay = false;
      });
    },
    getProductColorSizes: function getProductColorSizes() {
      var _this14 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/product-color-sizes/:product_id".replace(':product_id', this.product.id)).then(function (response) {
        _this14.PCSItems = response.data;
      }).catch(function (err) {
        _this14.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this14.overlay = false;
      });
    },
    showDetailProductColorSize: function showDetailProductColorSize(item) {
      this.product_color_size.id = item.id;
      this.product_color_size.product_color_id = item.product_color_id;
      this.product_color_size.size_id = item.size_id;
      this.product_color_size.stock = item.stock;
      this.product_color_size.status = item.status;
    },
    submitProductColorSize: function submitProductColorSize() {
      var _this15 = this;

      var color = '';
      for (var i = 0; i < this.PCItems.length; i++) {
        if (this.PCItems[i].id == this.product_color_size.product_color_id) {
          color = this.PCItems[i].color.name;
          break;
        }
      }

      if (color == 'NOT_COLOR') {
        var size = '';
        for (var j = 0; j < this.select.sizes.length; j++) {
          if (this.select.sizes[j].id == this.product_color_size.size_id) {
            size = this.select.sizes[j].name;
            break;
          }
        }

        if (size != 'NOT_SIZE') {
          this.showMessage('La talla permitida para un color NOT_COLOR es el NOT_SIZE, caso contrario registrar otro color', 'red');
          return;
        }
      }

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put("secure/product/color/size", this.product_color_size).then(function (response) {
        _this15.$refs.formProductColorSize.reset();
        _this15.showMessage(response.data.message, 'green');
      }).then(function () {
        _this15.cleanFormProductColorSize();
        _this15.getProductColorSizes();
      }).catch(function (err) {
        _this15.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this15.overlay = false;
      });
    }
  }, 'domwloadExcel', function domwloadExcel() {
    var _this16 = this;

    this.overlay = true;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("secure/product/color/size/stock", {
      responseType: 'blob',
      headers: {
        'Content-Type': 'text/xls'
      }
    }).then(function (response) {
      var fileURL = URL.createObjectURL(response.data);
      var a = document.createElement('a');
      a.setAttribute('href', fileURL);
      a.setAttribute('download', response.headers['name-file']);
      a.click();
    }).catch(function (err) {
      _this16.showMessage('Hubo un problema en el servidor', 'red');
    }).then(function () {
      _this16.overlay = false;
    });
  }),

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getProducts();
    this.getCategories();
    this.getBrands();
    this.getColors();
    this.getSizes();
  },
  watch: {
    dialog: function dialog(val) {
      if (val === false) {
        this.cleanFormProductColorSize();
        this.cleanFormProductColorImage();
        this.cleanFormProductColor();
        this.cleanForm();
        this.active = null;
        this.tab = 'tab-1';
      }
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_3__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      overlay: false,
      dialog: false,
      tab: null,
      panel: [0],
      panelOrder: [0, 2],
      // active: null,
      modal: false,
      dates: [__WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString().substr(0, 10), __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString().substr(0, 10)],
      date: __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString().substr(0, 10),
      searchProduct: {
        startDate: null,
        endDate: null
      },
      search: '',
      headers: [{ text: 'PEDIDO ID', value: 'id' }, { text: 'FECHA DE PEDIDO', value: 'created_at' }, { text: 'PROVEEDOR', value: 'supplier_name' }, { text: 'FECHA DE RECOJO O DELIVERY', value: 'delivery_day' }, { text: 'CANTIDAD PRODUCTOS', value: 'quantity' }, { text: 'TOTAL DELIVERY', value: 'shipping_price' }, { text: 'SUBTOTAL', value: 'subtotal' }, { text: 'TOTAL', value: 'total' }, { text: 'ESTADO', value: 'status' }, { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }],
      items: [],
      rules: {
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },
      productColorSizes: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'searchProduct', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'productCopy', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'select', {
      products: [],
      productColors: [],
      productColorSizes: []
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selected', {
      product: null,
      productColor: null,
      productColorSize: null
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'valid', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'validForm', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'modalDeliveryDay', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'orderSupplier', {
      id: null,
      supplier_name: null,
      shipping_price: null,
      subtotal: null,
      total: null,
      delivery_day: null,
      quantity: null,
      status: null
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'quantity', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'unit_price', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'OSHeaders', [{ text: 'PRODUCTO', value: 'product_name', width: '25%' }, { text: 'COLOR', value: 'product_color_name', width: '10%' }, { text: 'TALLA', value: 'product_color_size_name', width: '10%' }, { text: 'UNI.', value: 'quantity', width: '10%' }, { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' }, { text: 'TOTAL', value: 'amount', width: '20%' }, { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'OSItems', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'snackbar', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'text', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'color', 'green'), _ref;
  },

  computed: {
    dateRangeText: function dateRangeText() {
      var newDate = [];
      newDate[0] = this.formatDateInit(this.dates[0]);
      newDate[1] = this.formatDateInit(this.dates[1]);

      if (newDate[1]) {
        if (this.dates[1] < this.dates[0]) {
          var newStartDateOld = newDate[1];
          var newEndDateOld = newDate[0];
          newDate[0] = newStartDateOld;
          newDate[1] = newEndDateOld;
        }
      }

      if (newDate[0] && !newDate[1]) {
        newDate[1] = newDate[0];
      }

      var _newDate$0$split = newDate[0].split('/'),
          _newDate$0$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_newDate$0$split, 3),
          day = _newDate$0$split2[0],
          month = _newDate$0$split2[1],
          year = _newDate$0$split2[2];

      var start = year + '-' + month + '-' + day;

      var _newDate$1$split = newDate[1].split('/'),
          _newDate$1$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_newDate$1$split, 3),
          day2 = _newDate$1$split2[0],
          month2 = _newDate$1$split2[1],
          year2 = _newDate$1$split2[2];

      var end = year2 + '-' + month2 + '-' + day2;

      this.searchProduct.startDate = start;
      this.searchProduct.endDate = end;

      if (end) {
        if (end < start) {
          this.searchProduct.startDate = end;
          this.searchProduct.endDate = start;
        }
      }

      return newDate.join(' - ');
    },
    dateText: function dateText() {
      this.orderSupplier.delivery_day = this.date;
      return this.formatDateInit(this.date);
    },
    disabledBtnSave: function disabledBtnSave() {
      if (!this.orderSupplier.supplier_name || !this.orderSupplier.delivery_day || !this.orderSupplier.quantity || !this.orderSupplier.shipping_price || !this.orderSupplier.subtotal || !this.orderSupplier.total || this.OSItems.length == 0) {
        return true;
      }

      return false;
    }
  },
  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    formatDateInit: function formatDateInit(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },


    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("DD/MM/yyyy");
    },

    formatDateTime: function formatDateTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateTime).format("DD/MM/yyyy HH:mm:ss");
    },

    getOrderSuppliers: function getOrderSuppliers() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("secure/order-supplier", {
        params: {
          startDate: this.searchProduct.startDate,
          endDate: this.searchProduct.endDate
        }
      }).then(function (response) {
        _this.items = response.data;
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },
    getColorOrTextStatus: function getColorOrTextStatus(status, type) {
      var value = '';

      if (type === 'color') {
        if (status == 0) {
          value = 'red';
        } else if (status == 1) {
          value = 'blue';
        } else if (status == 2) {
          value = 'green';
        }
      } else if (type === 'text') {
        if (status == 0) {
          value = 'ANULADO';
        } else if (status == 1) {
          value = 'PROCESADO';
        } else if (status == 2) {
          value = 'RECEPCIONADO';
        }
      }

      return value;
    },
    searchArticulos: function searchArticulos(e) {
      var _this2 = this;

      if (!this.searchProduct) {
        this.select.products = this.productCopy;
      }

      this.select.products = this.productCopy.filter(function (product) {
        return product.name.toLowerCase().indexOf(_this2.searchProduct.toLowerCase()) > -1;
      });
    },
    cleanForm: function cleanForm() {
      this.selected.product = null;
      this.selected.productColor = null;
      this.selected.productColorSize = null;
      this.orderSupplier.id = null;
      this.orderSupplier.supplier_name = null;
      this.orderSupplier.shipping_price = null;
      this.orderSupplier.subtotal = null;
      this.orderSupplier.total = null;
      this.orderSupplier.delivery_day = null;
      this.orderSupplier.quantity = null;
      this.orderSupplier.status = null;
      this.date = __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString().substr(0, 10);
      this.OSItems = [];
      // this.$refs.form.reset();
    },
    getDetail: function getDetail(item) {
      this.overlay = true;
      this.orderSupplier.id = item.id;
      this.orderSupplier.supplier_name = item.supplier_name;
      this.orderSupplier.shipping_price = item.shipping_price;
      this.orderSupplier.subtotal = item.subtotal;
      this.orderSupplier.total = item.total;
      this.orderSupplier.delivery_day = item.delivery_day;
      this.orderSupplier.quantity = item.quantity;
      this.orderSupplier.status = item.status;
      this.date = item.delivery_day;
      this.OSItems = item.order_supplier_detail;
      this.dialog = true;
      this.overlay = false;
    },
    copy: function copy(item) {
      this.overlay = true;
      this.orderSupplier.id = null;
      this.orderSupplier.supplier_name = item.supplier_name;
      this.orderSupplier.shipping_price = item.shipping_price;
      this.orderSupplier.subtotal = item.subtotal;
      this.orderSupplier.total = item.total;
      this.orderSupplier.delivery_day = item.delivery_day;
      this.orderSupplier.quantity = item.quantity;
      this.orderSupplier.status = 1;
      this.date = item.delivery_day;
      this.OSItems = item.order_supplier_detail;
      this.dialog = true;
      this.overlay = false;
    },
    getProducts: function getProducts() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/secure/products').then(function (response) {
        _this3.select.products = response.data;
        _this3.productCopy = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
      }).catch(function (err) {}).then(function () {});
    },
    getProductColors: function getProductColors() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("secure/product/color/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this4.select.productColors = response.data;
      }).catch(function (err) {}).then(function () {});
    },
    getProductColorSizes: function getProductColorSizes() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("secure/product-color-sizes/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this5.productColorSizes = response.data;
      }).catch(function (err) {}).then(function () {
        if (_this5.select.productColors.length == 1 && _this5.select.productColors[0].color.name == 'NOT_COLOR') {
          _this5.selected.productColor = _this5.select.productColors[0].id;
        }
      });
    },
    addProduct: function addProduct() {
      var productName = void 0,
          productColorName = void 0,
          productColorSizeName = '';
      var self = this;

      this.select.products.forEach(function (obj) {
        if (obj.id == self.selected.product) {
          productName = obj.name;
          return;
        }
      });

      this.select.productColors.forEach(function (obj) {
        if (obj.id == self.selected.productColor) {
          productColorName = obj.color.name;
          return;
        }
      });

      this.select.productColorSizes.forEach(function (obj) {
        if (obj.id == self.selected.productColorSize) {
          productColorSizeName = obj.size.name;
          return;
        }
      });

      var amountForProduct = parseInt(this.quantity) * parseFloat(this.unit_price);
      this.OSItems.push({
        'product_id': this.selected.product,
        'product_color_id': this.selected.productColor,
        'product_color_size_id': this.selected.productColorSize,
        'product_name': productName,
        'product_color_name': productColorName,
        'product_color_size_name': productColorSizeName,
        'quantity': this.quantity,
        'unit_price': this.unit_price,
        'amount': amountForProduct.toFixed(2)
      });

      var amount = 0;
      var quantity = 0;
      this.OSItems.forEach(function (obj) {
        quantity = quantity + parseInt(obj.quantity);
        amount = parseFloat(amount) + parseFloat(obj.amount);
        amount = parseFloat(amount).toFixed(2);
      });

      this.orderSupplier.quantity = quantity;
      this.orderSupplier.subtotal = amount;
      this.orderSupplier.total = parseFloat(amount) + parseFloat(this.orderSupplier.shipping_price ? this.orderSupplier.shipping_price : 0);
      this.selected.product = null;
      this.selected.productColor = null;
      this.selected.productColorSize = null;
      this.select.productColors = [];
      this.select.productColorSizes = [];
      this.quantity = null;
      this.unit_price = null;
    },


    removeRow: function removeRow(index, item) {
      this.OSItems.splice(index, 1);
      this.orderSupplier.quantity -= parseInt(item.quantity);
      this.orderSupplier.subtotal -= item.amount;
      this.orderSupplier.total -= item.amount;
    },

    saveOrderSupplier: function saveOrderSupplier() {
      var _this6 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("secure/order-supplier", { 'orderSupplier': this.orderSupplier, 'orderSupplierDetail': this.OSItems }).then(function (response) {
        _this6.getOrderSuppliers();
        _this6.showMessage(response.data.message, 'green');
        _this6.dialog = false;
      }).catch(function (err) {
        _this6.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this6.overlay = false;
      });
    },
    updateStatusOrderSupplier: function updateStatusOrderSupplier(orderSupplierId, status) {
      var _this7 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put("secure/order-supplier", { 'id': orderSupplierId, 'status': status }).then(function (response) {
        _this7.getOrderSuppliers();
        _this7.showMessage(response.data.message, 'green');
        _this7.dialog = false;
      }).catch(function (err) {
        _this7.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this7.overlay = false;
      });
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getProducts();
    this.getOrderSuppliers();
  },
  watch: {
    dialog: function dialog(val) {
      if (val === false) {
        this.cleanForm();
        this.tab = 'tab-1';
        this.panelOrder = [0, 2];
      }
    },
    'selected.product': function selectedProduct(val) {
      if (val) {
        this.select.productColors = [];
        this.select.productColorSizes = [];
        this.getProductColors();
        this.getProductColorSizes();
      }
    },
    'selected.productColor': function selectedProductColor(val) {
      if (val) {
        var self = this;

        this.select.productColorSizes = [];
        this.productColorSizes.forEach(function (obj) {
          if (obj.product_color_id == val) {
            self.select.productColorSizes.push(obj);
          }
        });

        if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
          this.selected.productColorSize = this.select.productColorSizes[0].id;
        }
      }
    },
    'orderSupplier.shipping_price': function orderSupplierShipping_price(val) {
      if (val) {
        var subtotal = this.orderSupplier.subtotal ? this.orderSupplier.subtotal : 0;
        this.orderSupplier.total = parseFloat(subtotal) + parseFloat(val);
        this.orderSupplier.total = this.orderSupplier.total.toFixed(2);
      } else {
        this.orderSupplier.total = this.orderSupplier.subtotal;
      }
    }
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      panel: [0],
      search: '',
      headers: [{ text: 'PRODUCTO', value: 'product.name' }, { text: 'COLOR', value: 'product_color.color.name' }, { text: 'SIZE', value: 'product_color_size.size.name' }, { text: 'STOCK INICIAL', value: 'initial_stock' }, { text: 'STOCK ACTUAL', value: 'stock' }, { text: 'COSTO ENVÍO UNI.', value: 'unit_freight_price' }, { text: 'COSTO PRODUCTO UNI.', value: 'unit_product_price' }, { text: 'TOTAL COSTO PRODUCTO UNI.', value: 'total_unit_product_price' }, { text: 'FECHA CREACIÓN', value: 'created_at' }],
      items: [],
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },


    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format("DD MMMM YYYY");
    },

    stockCeroBackground: function stockCeroBackground(item) {
      return item.stock == 0 ? 'row-stock' : '';
    },

    getInventories: function getInventories() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/inventories").then(function (response) {
        _this.items = response.data;
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },
    domwloadExcel: function domwloadExcel() {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/inventories/excel", {
        responseType: 'blob',
        headers: {
          'Content-Type': 'text/xls'
        }
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getInventories();
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeImage',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      dialog: false,
      tab: null,
      panel: [0],
      active: null,
      modal: false,
      search: '',
      validProductColorImage: true,
      rules: {
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },
      select: {
        products: [],
        groups: [{ id: 'HOT WHEELS', name: 'HOT WHEELS' }, { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' }, { id: 'MINECRAFT', name: 'MINECRAFT' }, { id: 'JUEGOS DE MESA', name: 'JUEGOS DE MESA' }, { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' }, { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' }, { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' }, { id: 'BLAZE', name: 'BLAZE' }, { id: 'SMASHERS', name: 'SMASHERS' }, { id: 'MUÑECAS', name: 'MUÑECAS' }, { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' }, { id: 'NERF', name: 'NERF' }, { id: 'PLAY DOH', name: 'PLAY DOH' }, { id: 'SUPER MARIO', name: 'SUPER MARIO' }, { id: 'PRINCESAS', name: 'PRINCESAS' }, { id: 'FRIEND', name: 'FRIEND' }, { id: 'MUNDO BEBE', name: 'MUNDO BEBE' }, { id: 'DIDACTICOS', name: 'DIDACTICOS' }, { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' }, { id: 'ÚTILES', name: 'ÚTILES' }, { id: 'PELUCHES INTERACTIVOS', name: 'PELUCHES INTERACTIVOS' }, { id: 'MAQUILLAJE', name: 'MAQUILLAJE' }, { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' }, { id: 'NAVIDAD', name: 'NAVIDAD' }, { id: 'BLUEY', name: 'BLUEY' }],
        type: [{ id: '1', name: 'TAMAÑO COMPUTADORA' }, { id: '100', name: 'TAMAÑO CELULAR' }],
        status: [{ id: 1, name: 'ACTIVO' }, { id: 2, name: 'INACTIVO' }]
      },
      banner: {
        id: null,
        group: null,
        images: [],
        type: null,
        status: null
      },
      bannerHeader: [{ text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false }, { text: 'GRUPO', value: 'group' }, { text: 'ORDEN', value: 'order' }, { text: 'TIPO', value: 'type' }, { text: 'ESTADO', value: 'status' }],
      bannerBodyHeader: [{ text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false }, { text: 'GRUPO', value: 'group' }, { text: 'ORDEN', value: 'order' }, { text: 'ESTADO', value: 'status' }],
      bannerFooterHeader: [{ text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false }, { text: 'GRUPO', value: 'group' }, { text: 'TITULO', value: 'title' }, { text: 'ORDEN', value: 'order' }, { text: 'GRUPO DE IMÁGENES', value: 'group_row' }, { text: 'ESTADO', value: 'status' }],
      bannerBody: {
        id: null,
        group: null,
        images: [],
        type: null,
        status: null
      },
      bannerFooter: {
        id: null,
        group: null,
        title: null,
        group_row: null,
        images: [],
        status: null
      },
      imagesTmp: [],
      imagesTmpBody: [],
      imagesTmpFooter: [],
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green',
      // **********************************
      // ************ preview  ************
      device: 1,
      items: [],
      bodyList: [],
      footerList: [],
      allRowFooter: []
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    getColorOrTextStatus: function getColorOrTextStatus(status, type) {
      var value = '';

      if (type === 'color') {
        value = status == 1 ? 'green' : 'red';
      } else if (type === 'text') {
        value = status == 1 ? 'ACTIVO' : 'INACTIVO';
      }

      return value;
    },
    getProducts: function getProducts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/secure/products').then(function (response) {
        _this.select.products = response.data;
      }).catch(function (err) {}).then(function () {});
    },
    saveBanners: function saveBanners() {
      var _this2 = this;

      this.overlay = true;

      var request = {
        id: this.banner.id,
        group: this.banner.group,
        type: this.banner.type,
        images: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.banner.images),
        status: this.banner.status
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("secure/banner/header", request).then(function (response) {
        _this2.showMessage(response.data.message, 'green');
      }).then(function () {
        _this2.onUpload();
      }).then(function () {
        _this2.$refs.formProductColorImage.reset();
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
        _this2.getBanners();
      });
    },
    saveBannersBody: function saveBannersBody() {
      var _this3 = this;

      this.overlay = true;

      var request = {
        id: this.bannerBody.id,
        group: this.bannerBody.group,
        type: this.bannerBody.type,
        images: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bannerBody.images),
        status: this.bannerBody.status
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("secure/banner/body", request).then(function (response) {
        _this3.showMessage(response.data.message, 'green');
      }).then(function () {
        _this3.onUpload();
      }).then(function () {
        _this3.$refs.formProductColorImage.reset();
      }).catch(function (err) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this3.overlay = false;
        _this3.getBanners();
      });
    },
    saveBannersFooter: function saveBannersFooter() {
      var _this4 = this;

      this.overlay = true;

      var request = {
        id: this.bannerFooter.id,
        group: this.bannerFooter.group,
        title: this.bannerFooter.title,
        group_row: this.bannerFooter.group_row,
        images: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bannerFooter.images),
        status: this.bannerFooter.status
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("secure/banner/footer", request).then(function (response) {
        _this4.showMessage(response.data.message, 'green');
      }).then(function () {
        _this4.onUpload();
      }).then(function () {
        _this4.$refs.formProductColorImage.reset();
      }).catch(function (err) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this4.overlay = false;
        _this4.getBanners();
      });
    },
    onUpload: function onUpload() {
      var storage = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.storage();
      var metadata = {
        cacheControl: "public, max-age=31536000"
      };

      if (this.tab == 'tab-1') {
        this.imagesTmp.map(function (file, index) {
          var task = storage.ref('/img/banners/' + file.name).put(file, metadata);
        });
      } else if (this.tab == 'tab-2') {
        this.imagesTmpBody.map(function (file, index) {
          var task = storage.ref('/img/banners-body/' + file.name).put(file, metadata);
        });
      } else if (this.tab == 'tab-3') {
        this.imagesTmpFooter.map(function (file, index) {
          var task = storage.ref('/img/banners-footer/' + file.name).put(file, metadata);
        });
      }
    },
    imagesSelected: function imagesSelected(type) {
      var domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
      var img = [];

      if (type == 1) {
        this.imagesTmp.map(function (file, index) {
          var order = index + 1;

          var image = encodeURIComponent('/banners/' + file.name);
          image = domain.concat(image + '?alt=media');
          img.push({ image: image, order: order, name: file.name });
        });

        this.banner.images = img;
      } else if (type == 2) {
        this.imagesTmpBody.map(function (file, index) {
          var order = index + 1;

          var image = encodeURIComponent('/banners-body/' + file.name);
          image = domain.concat(image + '?alt=media');
          img.push({ image: image, order: order, name: file.name });
        });

        this.bannerBody.images = img;
      } else if (type == 3) {
        this.imagesTmpFooter.map(function (file, index) {
          var order = index + 1;

          var image = encodeURIComponent('/banners-footer/' + file.name);
          image = domain.concat(image + '?alt=media');
          img.push({ image: image, order: order, name: file.name });
        });

        this.bannerFooter.images = img;
      }
    },
    getBanners: function getBanners() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/secure/banners").then(function (response) {
        _this5.items = response.data.header;
        _this5.bodyList = response.data.body;
        _this5.footerList = response.data.footer;
        _this5.allRowFooter = response.data.allRowFooter;
      });
    },
    updateStatus: function updateStatus(type, item) {
      var _this6 = this;

      var request = {
        type: type,
        id: item.id,
        status: item.status == 1 ? 0 : 1
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/secure/banner/status", request).then(function (response) {
        _this6.showMessage(response.data.message, 'green');
      }).then(function () {
        _this6.getBanners();
      }).catch(function (err) {
        _this6.showMessage('Hubo un problema en el servidor', 'red');
      });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getBanners();
    this.getProducts();
  },
  watch: {
    dialog: function dialog(val) {
      if (val === false) {
        this.active = null;
        this.tab = 'tab-1';
      }
    }
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_order_index__ = __webpack_require__(269);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      dialog: false,
      dialogLabel: false,
      tab: null,
      panel: [0],
      panelOrder: [0],
      active: null,
      modal: false,
      date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().toISOString().substr(0, 10),
      search: '',
      headers: [{ text: 'NÚMERO PEDIDO', value: 'orderNumber', align: 'center', sortable: false }, { text: 'CELULAR', value: 'phone' }, { text: 'CLIENTE', value: 'full_name' }, { text: 'FECHA DE PEDIDO', value: 'created_at' }, { text: 'TOTAL DELIVERY', value: 'shipping_price' }, { text: 'SUBTOTAL', value: 'subtotal' }, { text: 'CUPÓN', value: 'coupon' }, { text: 'TOTAL', value: 'total' }, { text: 'FECHA DE DELIVERY', value: 'delivery_day' }, { text: 'DELIVERY PARTNER', value: 'delivery_partner' }, { text: 'ESTADO', value: 'status' }, { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }],
      items: [],
      valid: true,
      order: {
        id: null,
        delivery_day: null,
        quantity: null,
        shipping_type_id: null,
        shipping_price: null,
        subtotal: null,
        coupon: null,
        total: null,
        created_at: null,
        status: null,
        delivery_partner: null
      },
      client: {
        names: null,
        name: null,
        last_name: null,
        phone: null,
        email: null
      },
      address: {
        address: null,
        reference: null
      },
      ODHeaders: [{ text: 'GRUPO', value: 'product.group', width: '20%' }, { text: 'PRODUCTO', value: 'product.name', width: '30%' }, { text: 'UNIDADES', value: 'quantity', width: '10%' }, { text: 'PRECIO UNITARIO', value: 'unit_price', width: '20%' }, { text: 'TOTAL', value: 'amount', width: '20%' }],
      ODItems: [],
      labelDetail: null,
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },


    zfill: function zfill(number, width) {
      var numberOutput = Math.abs(number);
      var length = number.toString().length;
      var zero = "0";

      if (width <= length) {
        if (number < 0) {
          return "-" + numberOutput.toString();
        } else {
          return numberOutput.toString();
        }
      } else {
        if (number < 0) {
          return "-" + zero.repeat(width - length) + numberOutput.toString();
        } else {
          return zero.repeat(width - length) + numberOutput.toString();
        }
      }
    },

    getOrderNumber: function getOrderNumber(orderId, clientId) {
      return this.zfill(orderId, 9) + '-' + clientId.toString();
    },

    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format("DD/MM/yyyy");
    },

    formatDateTime: function formatDateTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateTime).format("DD/MM/yyyy HH:mm:ss");
    },

    getOrdersPlaced: function getOrdersPlaced() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/orders").then(function (response) {
        _this.items = Object(__WEBPACK_IMPORTED_MODULE_3__utils_order_index__["d" /* formatOrderList */])(response.data);
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },
    getColorOrTextStatus: function getColorOrTextStatus(status, type) {
      var value = '';

      if (type === 'color') {
        value = status == 1 ? 'green' : 'error';
      } else if (type === 'text') {
        value = status == 1 ? 'PROCESADO' : "ANULADO";
      }

      return value;
    },
    cleanForm: function cleanForm() {
      this.$refs.form.reset();
    },
    getDetail: function getDetail(item) {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/client/:client_id".replace(':client_id', item.client_id)), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/address/:address_id".replace(':address_id', item.address_id))]).then(function (response) {
        _this2.order.id = item.id;
        _this2.order.created_at = _this2.formatDateTime(item.created_at_original);
        _this2.order.quantity = item.quantity;
        _this2.order.shipping_type_id = item.shipping_type_id;
        _this2.order.shipping_price = item.shipping_price;
        _this2.order.subtotal = item.subtotal;
        _this2.order.coupon = item.coupon ? '-' + item.coupon : '';
        _this2.order.total = item.total;
        _this2.order.status = item.status;
        _this2.order.delivery_day = _this2.formatDate(item.delivery_day_original);
        _this2.order.delivery_partner = item.delivery_partner;
        _this2.ODItems = item.order_detail;
        _this2.client.names = response[0].data.name + ' ' + response[0].data.last_name;
        _this2.client.name = response[0].data.name;
        _this2.client.last_name = response[0].data.last_name;
        _this2.client.phone = response[0].data.phone;
        _this2.client.email = response[0].data.email;
        _this2.address.address = response[1].data.address;
        _this2.address.reference = response[1].data.reference;
        _this2.dialog = true;
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    },
    getLabel: function getLabel(item) {
      var _this3 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/client/:client_id".replace(':client_id', item.client_id)), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/address/:address_id".replace(':address_id', item.address_id))]).then(function (response) {
        _this3.client.names = (response[0].data.name ? response[0].data.name : '') + ' ' + (response[0].data.last_name ? response[0].data.last_name : '');

        var name = item.person_reception == 1 ? _this3.client.names : item.name_reception + ' ' + item.last_name_reception;
        var saldo = item.total;
        var identificador = _this3.getOrderNumber(item.id, item.client_id);

        _this3.labelDetail = 'DINO TOYS\n\nNOMBRE: ' + name + '\nDISTRITO: ' + (response[1].data.district ? response[1].data.district.name : '') + '\nDIRECCI\xD3N: ' + response[1].data.address + '\nNUMERO: ' + response[0].data.phone + '\nSALDO: ' + saldo + '\nIDENTIFICADOR: ' + identificador;

        _this3.dialogLabel = true;
      }).catch(function (err) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this3.overlay = false;
      });
    },
    updateStatusOrder: function updateStatusOrder(orderId, status) {
      var _this4 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("secure/order", { 'order_id': orderId, 'status': status }).then(function (response) {
        _this4.getOrdersPlaced();
        _this4.showMessage(response.data.message, 'green');
        _this4.dialog = false;
      }).catch(function (err) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this4.overlay = false;
      });
    },
    updateDeliveryPartner: function updateDeliveryPartner() {
      var _this5 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("secure/order/delivery-partner", { 'order_id': this.order.id, 'delivery_partner': this.order.delivery_partner }).then(function (response) {
        _this5.getOrdersPlaced();
        _this5.showMessage(response.data.message, 'green');
        _this5.dialog = false;
      }).catch(function (err) {
        _this5.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this5.overlay = false;
      });
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getOrdersPlaced();
  },
  watch: {
    dialog: function dialog(val) {
      if (val === false) {
        this.cleanForm();
        this.active = null;
        this.tab = 'tab-1';
        this.panelOrder = [0];
      }
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatReceivableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatReceivableDetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatReceivableModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatPartialOrderModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatClientModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAddressModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatPartialOrderDetailModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatDateDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatOrderList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var clientFullName = function clientFullName(name, lastName) {
	lastName = lastName || '';
	return name ? name.concat(' ', lastName) : lastName;
};

var formatDate = function formatDate(date) {
	return date ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format("DD MMMM YYYY") : null;
};

var formatOrderIdWithZero = function formatOrderIdWithZero(number, width) {
	var numberOutput = Math.abs(number);
	var length = number.toString().length;
	var zero = "0";

	if (width <= length) {
		if (number < 0) {
			return "-" + numberOutput.toString();
		} else {
			return numberOutput.toString();
		}
	} else {
		if (number < 0) {
			return "-" + zero.repeat(width - length) + numberOutput.toString();
		} else {
			return zero.repeat(width - length) + numberOutput.toString();
		}
	}
};

var formatOrderNumber = function formatOrderNumber(orderId, clientId) {
	return formatOrderIdWithZero(orderId, 9) + '-' + clientId.toString();
};

var formatReceivableList = function formatReceivableList(receivableList) {
	return receivableList.map(function (receivable) {
		return {
			'id': receivable.id,
			'partialOrderId': receivable.partial_order_id,
			'clientName': clientFullName(receivable.partial_order.client.name, receivable.partial_order.client.last_name),
			'phone': receivable.partial_order.client.phone,
			'openingDate': formatDate(receivable.opening_date),
			'deliveryDay': formatDate(receivable.partial_order.delivery_day) || 'FALTA AGENDAR',
			'total': receivable.total,
			'advancePayment': receivable.advance_payment,
			'pendingPayment': receivable.pending_payment,
			'orderId': receivable.partial_order.order_id,
			'status': receivable.status
		};
	});
};

var formatReceivableDetailList = function formatReceivableDetailList(receivableDetailList) {
	return receivableDetailList.map(function (receivableDetail) {
		return {
			'id': receivableDetail.id,
			'receivableId': receivableDetail.receivable_id,
			'payment': receivableDetail.payment,
			'paymentDate': formatDate(receivableDetail.payment_date)
		};
	});
};

var formatReceivableModel = function formatReceivableModel(receivable) {
	return {
		'id': receivable.id,
		'partialOrderId': receivable.partial_order_id,
		'total': receivable.total,
		'advancePayment': receivable.advance_payment,
		'pendingPayment': receivable.pending_payment,
		'orderId': receivable.partial_order.order_id,
		'status': receivable.status
	};
};

var formatPartialOrderModel = function formatPartialOrderModel(partialOrder) {
	return {
		'id': partialOrder.id,
		'client_id': partialOrder.client_id,
		'address_id': partialOrder.address_id,
		'payment_type_id': partialOrder.payment_type_id,
		'shipping_type_id': partialOrder.shipping_type_id,
		'shipping_price': partialOrder.shipping_price,
		'subtotal': partialOrder.subtotal,
		'coupon': partialOrder.coupon,
		'total': partialOrder.total,
		'advance_payment': partialOrder.advance_payment,
		'pending_payment': partialOrder.pending_payment,
		'delivery_day': partialOrder.delivery_day,
		'coupon_code': partialOrder.coupon_code,
		'opening_date': partialOrder.opening_date
	};
};

var formatClientModel = function formatClientModel(client) {
	return {
		'id': client.id,
		'email': client.email,
		'name': client.name,
		'last_name': client.last_name,
		'identification_doc': client.identification_doc,
		'phone': client.phone,
		'accept_conditions': client.accept_conditions,
		'status': client.status
	};
};

var formatAddressModel = function formatAddressModel(address) {
	return {
		'id': address.id,
		'shipping_type_id': address.shipping_type_id,
		'client_id': address.client_id,
		'department_id': address.department_id,
		'province_id': address.province_id,
		'district_id': address.district_id,
		'address': address.address,
		'reference': address.reference,
		'primary': address.primary,
		'status': address.status
	};
};

var formatPartialOrderDetailModel = function formatPartialOrderDetailModel(partialOrderDetailList) {
	return partialOrderDetailList.map(function (detail) {
		return {
			'id': detail.id,
			'product_id': detail.product_id,
			'product_color_id': detail.product_color_id,
			'product_color_size_id': detail.product_color_size_id,
			'product_name': detail.product.name,
			'product_color_name': detail.product_color.color.name,
			'product_color_size_name': detail.product_color_size.size.name,
			'quantity': detail.quantity,
			'unit_price': detail.unit_price,
			'amount': detail.amount
		};
	});
};

var formatDateDB = function formatDateDB(date) {
	if (!date) return null;

	var _date$substring$split = date.substring(0, 10).split('-'),
	    _date$substring$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$substring$split, 3),
	    year = _date$substring$split2[0],
	    month = _date$substring$split2[1],
	    day = _date$substring$split2[2];

	return day + '/' + month + '/' + year;
};

var formatOrderList = function formatOrderList(orderList) {
	// { text: 'NÚMERO PEDIDO', value: 'orderNumber', align: 'center', sortable: false},
	//          { text: 'PEDIDO ID', value: 'id'},
	//          { text: 'CLIENTE ID', value: 'client_id'},
	//          { text: 'CLIENTE', value: 'client.full_name'},
	//          { text: 'FECHA DE PEDIDO', value: 'created_at' },
	//          { text: 'TOTAL DELIVERY', value: 'shipping_price' },
	//          { text: 'SUBTOTAL', value: 'subtotal' },
	//          { text: 'CUPÓN', value: 'coupon' },
	//          { text: 'TOTAL', value: 'total' },
	//          { text: 'FECHA DE DELIVERY', value: 'delivery_day' },
	//          { text: 'DELIVERY PARTNER', value: 'delivery_partner' },
	//          { text: 'ESTADO', value: 'status' },
	//          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }

	return orderList.map(function (order) {
		return {
			'orderNumber': formatOrderNumber(order.id, order.client_id),
			'id': order.id,
			'client_id': order.client_id,
			'address_id': order.address_id,
			'phone': order.client.phone,
			'full_name': order.client.full_name,
			'created_at': formatDate(order.created_at),
			'shipping_price': order.shipping_price,
			'subtotal': order.subtotal,
			'coupon': order.coupon > 0 ? '-' + order.coupon : '',
			'total': order.total,
			'delivery_day': formatDate(order.delivery_day),
			'status': order.status,
			'person_reception': order.person_reception,
			'name_reception': order.name_reception,
			'last_name_reception': order.last_name_reception,
			'quantity': order.quantity,
			'shipping_type_id': order.shipping_type_id,
			'delivery_partner': order.delivery_partner,
			'order_detail': order.order_detail,
			'created_at_original': order.created_at,
			'delivery_day_original': order.delivery_day,
			'coupon_code': order.coupon_code
		};
	});
};

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderProfitView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      panel: [0],
      search: '',
      numberUnclosedOrders: 0,
      headers: [{ text: 'ID COMPRA', value: 'order_id' }, { text: 'TIPO DELIVERY', value: 'delivery_type' }, { text: 'DISTRITO', value: 'district' }, { text: 'PRECIO DELIVERY', value: 'shipping_price' }, { text: 'GANANCIA DE PRODUCTOS', value: 'profit' }, { text: 'FECHA CREACIÓN BALANCE', value: 'created_at' }],
      items: [],
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },


    getNowDate: function getNowDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("DD/MM/yyyy HH:mm:ss");
    },

    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format("DD/MM/yyyy HH:mm:ss");
    },

    getProfits: function getProfits() {
      var _this = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/order-profit").then(function (response) {
        _this.items = response.data.orderProfit;
        _this.numberUnclosedOrders = response.data.numberUnclosedOrders;
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this.overlay = false;
      });
    },
    domwloadExcel: function domwloadExcel() {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("secure/order-profit/excel", {
        responseType: 'blob',
        headers: {
          'Content-Type': 'text/xls'
        }
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getProfits();
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_html2canvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductsImage',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    return {
      overlay: false,
      disabledSubmit: true,
      groupSelected: null,
      productColors: [],
      page: 1,
      length: null,
      count: 10,
      orderBy: null,
      select: {
        groups: [{ id: 'HOT WHEELS', name: 'HOT WHEELS' }, { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' }, { id: 'MINECRAFT', name: 'MINECRAFT' }, { id: 'JUEGOS DE MESA', name: 'JUEGOS DE MESA' }, { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' }, { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' }, { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' }, { id: 'BLAZE', name: 'BLAZE' }, { id: 'SMASHERS', name: 'SMASHERS' }, { id: 'MUÑECAS', name: 'MUÑECAS' }, { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' }, { id: 'NERF', name: 'NERF' }, { id: 'PLAY DOH', name: 'PLAY DOH' }, { id: 'SUPER MARIO', name: 'SUPER MARIO' }, { id: 'PRINCESAS', name: 'PRINCESAS' }, { id: 'FRIEND', name: 'FRIEND' }, { id: 'MUNDO BEBE', name: 'MUNDO BEBE' }, { id: 'DIDACTICOS', name: 'DIDACTICOS' }, { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' }, { id: 'ÚTILES', name: 'ÚTILES' }, { id: 'PELUCHES INTERACTIVOS', name: 'PELUCHES INTERACTIVOS' }, { id: 'MAQUILLAJE', name: 'MAQUILLAJE' }, { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' }, { id: 'NAVIDAD', name: 'NAVIDAD' }, { id: 'BLUEY', name: 'BLUEY' }],
        filters: [{ id: 'OrderByPriceASC', name: 'Precio más bajo' }, { id: 'OrderByPriceDESC', name: 'Precio más alto' }, { id: 'OrderByReleaseDateDESC', name: 'Lo más nuevo' }, { id: 'OrderByBestDiscountDESC', name: 'Mejor descuento' }]
      },
      displayProductOff: false,
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  computed: {
    shownCards: function shownCards() {
      window.scrollTo(0, 0);
      var page = this.page,
          count = this.count,
          productColors = this.productColors;

      var number = Math.ceil(productColors.length / count);
      return productColors.slice((page - 1) * count, page * count);
    }
  },
  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    findProduct: function findProduct() {
      var _this = this;

      var filter = this.$route.query.q ? this.$route.query.q : this.groupSelected;
      var url = "/secure/product/search?q=" + filter + (this.orderBy ? '&orderBy=' + this.orderBy : '');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        _this.page = 1;
        _this.productColors = response.data;
        _this.length = Math.ceil(response.data.length / _this.count);
        _this.disabledSubmit = response.data.length > 0 ? false : true;
      }).catch(function (err) {});
    },
    generateImages: function generateImages() {
      var _this2 = this;

      this.disabledSubmit = true;
      this.showMessage('Generando imágenes, esperar por favor...', 'green');
      this.shownCards.forEach(function (value, index) {
        var canvas = __WEBPACK_IMPORTED_MODULE_3_html2canvas___default()(_this2.$refs[value.id][0], {
          scale: 5,
          allowTaint: false,
          useCORS: true,
          proxy: "https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com"
        }).then(function (canvas) {
          var link = document.createElement('a');
          link.download = value.product.name + '.jpg';
          link.href = canvas.toDataURL();
          link.click();
        });
      });
      setTimeout(function () {
        return _this2.disabledSubmit = false;
      }, 7000);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };
  },
  watch: {
    '$route.query.q': function $routeQueryQ(val) {
      if (val) {
        this.findProduct();
      }
    },
    'groupSelected': function groupSelected(val) {
      if (val) {
        this.findProduct();
      }
    }
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_2__layouts_DefaultLayout__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
  },
  data: function data() {
    return {
      overlay: false,
      dialog: false,
      panel: [0, 1, 2],
      date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toISOString(true).substr(0, 10),
      rules: {
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },
      findClient: null,
      modalDeliveryDay: false,
      provinces: [],
      districts: [],
      deliveryDistricts: [],
      searchProduct: '',
      productCopy: [],
      productColorSizes: [],
      select: {
        deliveryTypes: [{ id: 1, name: 'DELIVERY' }, { id: 2, name: 'RETIRO EN TIENDA' }, { id: 3, name: 'SHALOM, MARVISUR U OTRO' }],
        departments: [],
        provinces: [],
        districts: [],
        products: [],
        productColors: [],
        productColorSizes: []
      },
      selected: {
        product: null,
        productColor: null,
        productColorSize: null
      },
      productColorImageUrl: null,
      partialOrder: {
        id: null,
        client_id: null,
        address_id: null,
        payment_type_id: null,
        shipping_type_id: null,
        shipping_price: 0,
        subtotal: null,
        coupon: 0,
        total: null,
        advance_payment: 0,
        pending_payment: null,
        coupon_code: null,
        opening_date: null
      },
      client: {
        id: null,
        email: null,
        name: null,
        last_name: '',
        identification_doc: null,
        phone: null,
        accept_conditions: 1,
        status: 1
      },
      address: {
        id: null,
        shipping_type_id: null,
        client_id: null,
        department_id: null,
        province_id: null,
        district_id: null,
        address: null,
        reference: null,
        primary: 1,
        status: 1
      },
      unit_price: null,
      quantity: null,
      off: null,
      stock: null,
      partialOrderHeaders: [{ text: 'PRODUCTO', value: 'product_name', width: '25%' }, { text: 'COLOR', value: 'product_color_name', width: '10%' }, { text: 'TALLA', value: 'product_color_size_name', width: '10%' }, { text: 'UNI.', value: 'quantity', width: '10%' }, { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' }, { text: 'TOTAL', value: 'amount', width: '20%' }, { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }],
      partialOrderItems: [],
      dialogClients: false,
      tab: null,
      expanded: [],
      validForm: true,
      searchClientTable: '',
      headers: [{ text: 'NOMBRE', value: 'name' }, { text: 'APELLIDO', value: 'last_name' }, { text: 'DNI/CE', value: 'identification_doc' }, { text: 'CELULAR', value: 'phone' }, { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }],
      items: [],
      radioGroup: null,
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  computed: {
    dateText: function dateText() {
      this.partialOrder.opening_date = this.date;
      return this.formatDateInit(this.date);
    },
    filteredDepartments: function filteredDepartments() {
      return this.select.departments.filter(function (item) {
        return item.store == 1;
      });
    },
    filteredProvinces: function filteredProvinces() {
      return this.select.provinces.filter(function (item) {
        return item.store == 1;
      });
    },
    filteredDistricts: function filteredDistricts() {
      return this.select.districts.filter(function (item) {
        return item.store == 1;
      });
    }
  },
  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    formatDateInit: function formatDateInit(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    onInputFindClient: function onInputFindClient(value) {
      // Si el valor contiene al menos un dígito
      if (/^[0-9\s]+$/.test(value)) {
        // Elimina todos los espacios
        this.findClient = value.replace(/\s+/g, '');
      } else {
        // Si no es numérico, deja el texto como está
        this.findClient = value;
      }
    },
    getDeliveryDistricts: function getDeliveryDistricts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/secure/deliveries").then(function (response) {
        _this.select.departments = response.data.departments;
        _this.provinces = response.data.provinces;
        _this.districts = response.data.districts;
        _this.deliveryDistricts = response.data.deliveryDistricts;
      }).catch(function (err) {}).then(function () {});
    },
    searchClient: function searchClient() {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/secure/client?q=" + this.findClient).then(function (response) {
        if (response.data.length == 0) {
          _this2.showMessage('No se encontr\xF3 cliente con estos datos de b\xFAsqueda "' + _this2.findClient + '"', 'deep-purple accent-4');
          _this2.cleanForm();
        } else if (response.data.length == 1) {
          _this2.client = response.data[0];
          var addressSize = response.data[0].address ? response.data[0].address.length : null;
          var latestAddress = addressSize ? response.data[0].address[addressSize - 1] : null;

          if (latestAddress) {
            _this2.address.id = latestAddress.id;
            _this2.address.shipping_type_id = latestAddress.shipping_type_id;
            _this2.address.client_id = latestAddress.client_id;
            _this2.address.department_id = latestAddress.department_id;
            _this2.address.province_id = latestAddress.province_id;
            _this2.address.district_id = latestAddress.district_id;
            _this2.address.address = latestAddress.address;
            _this2.address.reference = latestAddress.reference;
            _this2.address.primary = latestAddress.primary;
          }
        } else if (response.data.length > 1) {
          _this2.dialogClients = true;
          _this2.items = response.data;
        }
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    },
    getProducts: function getProducts() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/products").then(function (response) {
        _this3.select.products = response.data;
        _this3.productCopy = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
      }).catch(function (err) {}).then(function () {});
    },
    searchArticulos: function searchArticulos(e) {
      var _this4 = this;

      if (!this.searchProduct) {
        this.select.products = this.productCopy;
      }

      this.select.products = this.productCopy.filter(function (product) {
        return product.name.toLowerCase().indexOf(_this4.searchProduct.toLowerCase()) > -1;
      });
    },
    getProductColors: function getProductColors() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product/color/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this5.select.productColors = response.data;
      }).catch(function (err) {}).then(function () {});
    },
    getProductColorSizes: function getProductColorSizes() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product-color-sizes/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this6.productColorSizes = response.data;
      }).catch(function (err) {}).then(function () {
        if (_this6.select.productColors.length == 1 && _this6.select.productColors[0].color.name == 'NOT_COLOR') {
          _this6.selected.productColor = _this6.select.productColors[0].id;
        }
      });
    },
    validateStock: function validateStock() {
      this.partialOrderItems.forEach(function (obj) {
        amount = parseFloat(amount) + parseFloat(obj.amount);
        amount = parseFloat(amount).toFixed(2);
      });
    },
    addProduct: function addProduct() {
      if (this.quantity > this.stock) {
        this.showMessage('Cantidad a comprar excede el stock actual', 'deep-purple accent-4');
        return;
      }

      var productName = void 0,
          productColorName = void 0,
          productColorSizeName = '';
      var self = this;

      this.select.products.forEach(function (obj) {
        if (obj.id == self.selected.product) {
          productName = obj.name;
          return;
        }
      });

      this.select.productColors.forEach(function (obj) {
        if (obj.id == self.selected.productColor) {
          productColorName = obj.color.name;
          return;
        }
      });

      this.select.productColorSizes.forEach(function (obj) {
        if (obj.id == self.selected.productColorSize) {
          productColorSizeName = obj.size.name;
          return;
        }
      });

      var amountForProduct = parseInt(this.quantity) * parseFloat(this.unit_price);
      this.partialOrderItems.push({
        'product_id': this.selected.product,
        'product_color_id': this.selected.productColor,
        'product_color_size_id': this.selected.productColorSize,
        'product_name': productName,
        'product_color_name': productColorName,
        'product_color_size_name': productColorSizeName,
        'quantity': this.quantity,
        'unit_price': this.unit_price,
        'amount': amountForProduct.toFixed(2)
      });

      var amount = 0;
      this.partialOrderItems.forEach(function (obj) {
        amount = parseFloat(amount) + parseFloat(obj.amount);
        amount = parseFloat(amount).toFixed(2);
      });

      this.partialOrder.subtotal = amount;
      this.calculeAmounts();
      this.selected.product = null;
      this.selected.productColor = null;
      this.selected.productColorSize = null;
      this.select.productColors = [];
      this.select.productColorSizes = [];
      this.quantity = null;
      this.unit_price = null;
      this.off = null;
      this.productColorImageUrl = null;
      this.stock = null;
    },
    getColorOrTextStatus: function getColorOrTextStatus(status, type) {
      var value = '';

      if (type === 'color') {
        value = status == 1 ? 'green' : 'red';
      } else if (type === 'text') {
        value = status == 1 ? 'ACTIVO' : 'INACTIVO';
      }

      return value;
    },
    selectdClient: function selectdClient(item) {
      this.client.id = item.id;
      this.client.email = item.email;
      this.client.name = item.name;
      this.client.last_name = item.last_name;
      this.client.identification_doc = item.identification_doc;
      this.client.phone = item.phone;
      this.client.accept_conditions = item.accept_conditions;
      this.client.status = item.status;

      if (this.radioGroup) {
        this.address.id = this.radioGroup.id;
        this.address.shipping_type_id = this.radioGroup.shipping_type_id;
        this.address.client_id = this.radioGroup.client_id;
        this.address.department_id = this.radioGroup.department_id;
        this.address.province_id = this.radioGroup.province_id;
        this.address.district_id = this.radioGroup.district_id;
        this.address.address = this.radioGroup.address;
        this.address.reference = this.radioGroup.reference;
        this.address.primary = this.radioGroup.primary;
        this.address.status = this.radioGroup.status;
        this.dialogClients = false;
      }
    },
    cleanForm: function cleanForm() {
      this.partialOrder.id = null;
      this.partialOrder.client_id = null;
      this.partialOrder.address_id = null;
      this.partialOrder.payment_type_id = null;
      this.partialOrder.shipping_type_id = null;
      this.partialOrder.shipping_price = 0;
      this.partialOrder.subtotal = null;
      this.partialOrder.coupon = 0;
      this.partialOrder.total = null;
      this.partialOrder.advance_payment = 0;
      this.partialOrder.pending_payment = null;
      this.partialOrder.coupon_code = null;
      this.partialOrder.opening_date = this.date;
      this.client.id = null;
      this.client.email = null;
      this.client.name = null;
      this.client.last_name = '';
      this.client.identification_doc = null;
      this.client.phone = null;
      this.client.accept_conditions = 1;
      this.client.status = 1;
      this.address.id = null;
      this.address.shipping_type_id = null;
      this.address.client_id = null;
      this.address.department_id = null;
      this.address.province_id = null;
      this.address.district_id = null;
      this.address.address = null;
      this.address.reference = null;
      this.address.primary = null;
      this.address.status = 1;
      this.partialOrderItems = [];
    },
    getProductImagesForTypeAndColor: function getProductImagesForTypeAndColor() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product/color/:product_color_id/images/:type".replace(':product_color_id', this.selected.productColor).replace(':type', 'mediano')).then(function (response) {
        var self = _this7;
        response.data.forEach(function (obj) {
          if (obj.order == 1) {
            self.productColorImageUrl = obj.image;
          }
        });
      }).catch(function (err) {});
    },
    calculeAmounts: function calculeAmounts() {
      var subtotal = parseFloat(this.partialOrder.subtotal) || 0;
      var shippingPrice = parseFloat(this.partialOrder.shipping_price) || 0;
      var coupon = parseFloat(this.partialOrder.coupon) || 0;
      var total = parseFloat(subtotal + shippingPrice - coupon).toFixed(2);
      var advancePayment = this.partialOrder.advance_payment ? parseFloat(this.partialOrder.advance_payment) : 0;

      this.partialOrder.total = total;
      this.partialOrder.pending_payment = parseFloat(total - advancePayment).toFixed(2);
    },


    removeRow: function removeRow(index, item) {
      this.partialOrderItems.splice(index, 1);
      this.partialOrder.subtotal -= parseFloat(item.amount).toFixed(2);
      this.partialOrder.total -= parseFloat(item.amount).toFixed(2);
      this.calculeAmounts();
    },

    saveSale: function saveSale() {
      var _this8 = this;

      if (this.partialOrder.pending_payment < 0) {
        this.showMessage('El monto pendiente a pagar no puede ser negativo, validar si el adelanto es mayor al monto total.', 'deep-purple accent-4');
        return;
      }

      if (!this.client.name) {
        this.showMessage('Falta ingresar nombre de cliente.', 'deep-purple accent-4');
        return;
      }

      if (!this.client.phone) {
        this.showMessage('Falta inngresar n\xFAmero de celular.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.shipping_price < 0) {
        this.showMessage('El costo de entrega no puede ser negativo.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.coupon < 0) {
        this.showMessage('El descuento del cup\xF3n no puede ser negativo.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.advance_payment < 0) {
        this.showMessage('El adelanto no puede ser negativo.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.shipping_price === '' || this.partialOrder.shipping_price === null || isNaN(this.partialOrder.shipping_price)) {
        this.partialOrder.shipping_price = 0;
      }

      if (this.partialOrder.coupon === '' || this.partialOrder.coupon === null || isNaN(this.partialOrder.coupon)) {
        this.partialOrder.coupon = 0;
      }

      if (this.partialOrder.advance_payment === '' || this.partialOrder.advance_payment === null || isNaN(this.partialOrder.advance_payment)) {
        this.partialOrder.advance_payment = 0;
      }

      var request = {
        'client': this.client,
        'address': this.address,
        'partialOrder': this.partialOrder,
        'partialOrderDetail': this.partialOrderItems
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/partial-order", request).then(function (response) {
        var color = response.data.success ? 'green' : 'red';
        _this8.showMessage(response.data.message, color);
        if (response.data.success) {
          _this8.cleanForm();
        }
      }).catch(function (err) {
        _this8.showMessage('Hubo un problema en el servidor', 'red');
      });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getDeliveryDistricts();
    this.getProducts();
  },
  watch: {
    'address.department_id': function addressDepartment_id(val) {
      if (val) {
        var self = this;
        this.provinces.forEach(function (obj) {
          if (obj.department_id == val) {
            self.select.provinces.push(obj);
          }
        });
      }
    },
    'address.province_id': function addressProvince_id(val) {
      if (val) {
        var self = this;
        this.districts.forEach(function (obj) {
          if (obj.province_id == val) {
            self.select.districts.push(obj);
          }
        });
      }
    },
    'address.district_id': function addressDistrict_id(val) {
      if (val) {
        if (this.address.shipping_type_id == 1) {
          var self = this;
          this.deliveryDistricts.forEach(function (obj) {
            if (obj.district_id == val) {
              if (obj.size == 2) {
                self.partialOrder.shipping_price = obj.price;
                var coupon = self.partialOrder.coupon > 0 ? self.partialOrder.coupon : 0;
                var total = parseFloat(self.partialOrder.subtotal) + parseFloat(obj.price) - parseFloat(coupon);
                self.partialOrder.total = parseFloat(total).toFixed(2);
              }
            }
          });
        } else if (this.address.shipping_type_id == 2) {
          this.address.address = 'Almacén Villa el Salvador\nAv. Mariano Pastor Sevilla & Av. Talara, Villa EL Salvador 15837';
        } else if (this.address.shipping_type_id == 3) {
          this.address.address = 'SHALOM';
        }
      }
    },
    'selected.product': function selectedProduct(val) {
      if (val) {
        var self = this;
        this.select.productColors = [];
        this.select.productColorSizes = [];
        this.select.products.forEach(function (obj) {
          if (obj.id == self.selected.product) {
            self.unit_price = obj.off > 0 ? obj.sale_price : obj.regular_price;
            self.off = obj.off;
            return;
          }
        });
        this.getProductColors();
        this.getProductColorSizes();
      }
    },
    'selected.productColor': function selectedProductColor(val) {
      if (val) {
        var self = this;

        this.select.productColorSizes = [];
        this.productColorSizes.forEach(function (obj) {
          if (obj.product_color_id == val) {
            self.select.productColorSizes.push(obj);
          }
        });

        if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
          this.selected.productColorSize = this.select.productColorSizes[0].id;
        }

        this.getProductImagesForTypeAndColor();
      }
    },
    'selected.productColorSize': function selectedProductColorSize(val) {
      if (val) {
        var self = this;
        this.productColorSizes.forEach(function (obj) {
          if (obj.id == val) {
            self.stock = obj.stock;
          }
        });
      }
    },
    'partialOrder.shipping_price': function partialOrderShipping_price(newShippingPrice, oldShippingPrice) {
      if (newShippingPrice != oldShippingPrice) {
        this.calculeAmounts();
      }
    },
    'partialOrder.coupon': function partialOrderCoupon(newCoupon, oldCoupon) {
      if (newCoupon !== oldCoupon) {
        this.calculeAmounts();
      }
    },
    'partialOrder.advance_payment': function partialOrderAdvance_payment(val) {
      val = parseFloat(val) || 0;
      this.partialOrder.pending_payment = parseFloat(this.partialOrder.total - parseFloat(val).toFixed(2)).toFixed(2);
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_order_index__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_error_index__ = __webpack_require__(465);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReceivableView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_2__layouts_DefaultLayout__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      overlay: false,
      panel: [0, 2],
      search: '',
      headers: [{ text: 'CLIENTE', value: 'clientName' }, { text: 'CELULAR', value: 'phone' }, { text: 'FECHA APERTURA', value: 'openingDate' }, { text: 'FECHA DE ENTREGA', value: 'deliveryDay' }, { text: 'TOTAL', value: 'total' }, { text: 'ADELANTO', value: 'advancePayment' }, { text: 'PENDIENTE', value: 'pendingPayment' }, { text: '', value: 'status', filterable: false, sortable: false }, { text: '', value: 'actions', filterable: false, sortable: false }],
      items: [],
      dialog: false,
      tab: null,
      shoppingBagDialog: false,
      shoppingBagTab: null,
      receivable: {
        id: null,
        partialOrderId: null,
        total: null,
        advancePayment: null,
        pendingPayment: null,
        orderId: null
      },
      payment: null,
      paymentDate: null,
      valid: true,
      rules: {
        required: function required(v) {
          return !!v || 'Por favor completar este campo';
        }
      },
      receivableDetailHeaders: [{ text: 'PAGO', value: 'payment' }, { text: 'FECHA DE PAGO', value: 'paymentDate' }, { text: '', value: 'actions', filterable: false, sortable: false }],
      receivableDetailItems: [],
      confirmDialogDelete: false,
      paymentToDelete: {
        id: null,
        receivableId: null,
        payment: null,
        paymentDate: null
      },
      modalPaymentDay: false,
      date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toISOString().substr(0, 10),
      confirmDialogGenerateOrder: false,
      confirmDialogCancelShoppingBag: false,
      receivableToGenerateOrder: {
        id: null,
        advancePayment: null,
        clientName: null,
        openingDate: null,
        partialOrderId: null,
        pendingPayment: null,
        phone: null,
        total: null
      },
      // ********** partial order *********
      modalDeliveryDay: false,
      modalRegistrationDay: false,
      deliveryDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toISOString().substr(0, 10),
      registrationDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toISOString().substr(0, 10),
      provinces: [],
      districts: [],
      deliveryDistricts: [],
      searchProduct: '',
      productCopy: [],
      productColorSizes: [],
      select: {
        deliveryTypes: [{ id: 1, name: 'DELIVERY' }, { id: 2, name: 'RETIRO EN TIENDA' }, { id: 3, name: 'SHALOM, MARVISUR U OTRO' }],
        departments: [],
        provinces: [],
        districts: [],
        products: [],
        productColors: [],
        productColorSizes: [],
        status: [{ id: 1, name: 'BOLSITA ABIERTA' }, { id: 0, name: 'BOLSITA LIBERADA' }]
      },
      selected: {
        product: null,
        productColor: null,
        productColorSize: null
      },
      productColorImageUrl: null,
      partialOrder: {
        id: null,
        client_id: null,
        address_id: null,
        payment_type_id: null,
        shipping_type_id: null,
        shipping_price: null,
        subtotal: null,
        coupon: null,
        total: null,
        advance_payment: null,
        pending_payment: null,
        delivery_day: null,
        coupon_code: null,
        opening_date: null
      },
      client: {
        id: null,
        email: null,
        name: null,
        last_name: null,
        identification_doc: null,
        phone: null,
        accept_conditions: 1,
        status: 1
      },
      address: {
        id: null,
        shipping_type_id: null,
        client_id: null,
        department_id: null,
        province_id: null,
        district_id: null,
        address: null,
        reference: null,
        primary: 1,
        status: 1
      },
      unit_price: null,
      quantity: null,
      off: null,
      stock: null,
      partialOrderHeaders: [{ text: 'PRODUCTO', value: 'product_name', width: '25%' }, { text: 'COLOR', value: 'product_color_name', width: '10%' }, { text: 'TALLA', value: 'product_color_size_name', width: '10%' }, { text: 'UNI.', value: 'quantity', width: '10%' }, { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' }, { text: 'TOTAL', value: 'amount', width: '20%' }, { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }],
      partialOrderItems: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tab', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'expanded', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'validForm', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchClientTable', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'radioGroup', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filter', {
      showCreatedOrders: false,
      status: 1
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'snackbar', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'text', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'color', 'green'), _ref;
  },

  computed: {
    dateText: function dateText() {
      this.paymentDate = this.date;
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["c" /* formatDateDB */])(this.date);
    },
    deliveryDateText: function deliveryDateText() {
      this.partialOrder.delivery_day = this.deliveryDate;
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["c" /* formatDateDB */])(this.deliveryDate);
    },
    registrationDateText: function registrationDateText() {
      this.partialOrder.opening_date = this.registrationDate;
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["c" /* formatDateDB */])(this.registrationDate);
    },
    filteredDepartments: function filteredDepartments() {
      return this.select.departments.filter(function (item) {
        return item.store == 1;
      });
    },
    filteredProvinces: function filteredProvinces() {
      return this.select.provinces.filter(function (item) {
        return item.store == 1;
      });
    },
    filteredDistricts: function filteredDistricts() {
      return this.select.districts.filter(function (item) {
        return item.store == 1;
      });
    }
  },
  methods: {
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    onInputFindClient: function onInputFindClient(value) {
      // Si el valor contiene al menos un dígito
      if (/^[0-9\s]+$/.test(value)) {
        // Elimina todos los espacios
        this.search = value.replace(/\s+/g, '');
      } else {
        // Si no es numérico, deja el texto como está
        this.search = value;
      }
    },
    getReceivable: function getReceivable() {
      var _this = this;

      this.overlay = true;

      var status = this.filter.status;
      var showCreatedOrders = this.filter.showCreatedOrders;
      var URL = "/secure/receivable?status=:status&showCreatedOrders=:showCreatedOrders".replace(':status', status).replace(':showCreatedOrders', showCreatedOrders);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(URL).then(function (response) {
        _this.items = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["h" /* formatReceivableList */])(response.data);
      }).catch(function (err) {
        _this.showMessage('Hubo un problema en el servidor', 'red');
        console.error(error);
      }).then(function () {
        _this.overlay = false;
      });
    },
    findReceivableForId: function findReceivableForId(id) {
      var _this2 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/secure/receivable/:id".replace(':id', id)).then(function (response) {
        _this2.receivable = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["i" /* formatReceivableModel */])(response.data);
        _this2.partialOrder = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["f" /* formatPartialOrderModel */])(response.data.partial_order);
        _this2.client = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["b" /* formatClientModel */])(response.data.partial_order.client);
        _this2.address = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["a" /* formatAddressModel */])(response.data.partial_order.address);
        _this2.deliveryDate = response.data.partial_order.delivery_day ? response.data.partial_order.delivery_day.substring(0, 10) : null;
        _this2.registrationDate = response.data.partial_order.opening_date ? response.data.partial_order.opening_date.substring(0, 10) : null;
        _this2.partialOrderItems = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["e" /* formatPartialOrderDetailModel */])(response.data.partial_order.partial_order_detail);
      }).catch(function (err) {
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.findReceivableDetail(id);
        _this2.overlay = false;
      });
    },
    findReceivableDetail: function findReceivableDetail(receivableId) {
      var _this3 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/secure/receivable/:receivableId/detail".replace(':receivableId', receivableId)).then(function (response) {
        _this3.receivableDetailItems = Object(__WEBPACK_IMPORTED_MODULE_5__utils_order_index__["g" /* formatReceivableDetailList */])(response.data);
      }).catch(function (err) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this3.overlay = false;
      });
    },
    savePartialPayment: function savePartialPayment() {
      var _this4 = this;

      this.overlay = true;

      if (this.payment == 0) {
        this.showMessage('Ingresar monto a pagar.', 'deep-purple accent-4');
        return;
      }

      var request = {
        payment: this.payment,
        paymentDate: this.paymentDate,
        receivableId: this.receivable.id,
        partialOrderId: this.receivable.partialOrderId
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/receivable/payment", request).then(function (response) {
        _this4.showMessage(response.data.message, response.data.success ? 'green' : 'red');
      }).catch(function (err) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this4.findReceivableForId(_this4.receivable.id);
        _this4.getReceivable();
        _this4.payment = null;
        _this4.overlay = false;
      });
    },
    cleanReceivableSelected: function cleanReceivableSelected() {
      this.receivable.id = null;
      this.receivable.partialOrderId = null;
      this.receivable.total = null;
      this.receivable.advancePayment = null;
      this.receivable.pendingPayment = null;
      this.receivable.orderId = null;
      this.payment = null;
    },
    selectedPaymentToDelete: function selectedPaymentToDelete(item) {
      this.paymentToDelete.id = item.id;
      this.paymentToDelete.receivableId = item.receivableId;
      this.paymentToDelete.payment = item.payment;
      this.paymentToDelete.paymentDate = item.paymentDate;
      this.confirmDialogDelete = true;
    },
    cofirmDeletion: function cofirmDeletion(deletePaymemnt) {
      if (deletePaymemnt) {
        this.deletedPayment(this.paymentToDelete);
      } else {
        this.paymentToDelete.id = null;
        this.paymentToDelete.receivableId = null;
        this.paymentToDelete.payment = null;
        this.paymentToDelete.paymentDate = null;
      }
      this.confirmDialogDelete = false;
    },
    deletedPayment: function deletedPayment(item) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/receivable/detail/:id".replace(':id', item.id)).then(function (response) {
        _this5.showMessage(response.data.message, response.data.success ? 'green' : 'red');
      }).catch(function (err) {
        _this5.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this5.findReceivableForId(item.receivableId);
      });
    },
    cleamShoppingBag: function cleamShoppingBag() {
      this.selected.product = null;
      this.selected.productColor = null;
      this.selected.productColorSize = null;

      this.productColorImageUrl = null;

      this.partialOrder.id = null;
      this.partialOrder.client_id = null;
      this.partialOrder.address_id = null;
      this.partialOrder.payment_type_id = null;
      this.partialOrder.shipping_type_id = null;
      this.partialOrder.shipping_price = null;
      this.partialOrder.subtotal = null;
      this.partialOrder.coupon = null;
      this.partialOrder.total = null;
      this.partialOrder.advance_payment = null;
      this.partialOrder.pending_payment = null;
      this.partialOrder.delivery_day = null;
      this.partialOrder.coupon_code = null;
      this.partialOrder.opening_date = null;

      this.client.id = null;
      this.client.email = null;
      this.client.name = null;
      this.client.last_name = null;
      this.client.identification_doc = null;
      this.client.phone = null;
      this.client.accept_conditions = 1;
      this.client.status = 1;

      this.address.id = null;
      this.address.shipping_type_id = null;
      this.address.client_id = null;
      this.address.department_id = null;
      this.address.province_id = null;
      this.address.district_id = null;
      this.address.address = null;
      this.address.reference = null;
      this.address.primary = 1;
      this.address.status = 1;

      this.unit_price = null;
      this.quantity = null;
      this.off = null;
      this.stock = null;
      this.partialOrderItems = [];
    },
    cofirmGenerateOrder: function cofirmGenerateOrder(deletePaymemnt) {
      if (deletePaymemnt) {
        this.generateOrder();
      } else {
        this.confirmDialogGenerateOrder = false;
      }
    },
    generateOrder: function generateOrder() {
      var _this6 = this;

      if (!this.partialOrder.delivery_day) {
        this.showMessage('Para generar su orden de compra debe ingresar la FECHA DE ENTREGA.', 'deep-purple accent-4');
        return;
      }

      if (!this.address.shipping_type_id) {
        this.showMessage('Para generar su orden de compra debe seleccionar el TIPO DE ENTREGA.', 'deep-purple accent-4');
        return;
      }

      if (this.address.shipping_type_id == 1 || this.address.shipping_type_id == 2) {
        if (!this.address.department_id) {
          this.showMessage('Para generar su orden de compra debe seleccionar el DEPARTAMENTO.', 'deep-purple accent-4');
          return;
        }

        if (!this.address.province_id) {
          this.showMessage('Para generar su orden de compra debe seleccionar la PROVINCIA.', 'deep-purple accent-4');
          return;
        }

        if (!this.address.district_id) {
          this.showMessage('Para generar su orden de compra debe seleccionar el DISTRITO.', 'deep-purple accent-4');
          return;
        }
      }

      if (!this.address.address) {
        this.showMessage('Para generar su orden de compra debe ingresar una DIRECCIÓN de entrega.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.total < 0) {
        this.showMessage('Para generar su orden de compra, el TOTAL no debe ser negativo.', 'deep-purple accent-4');
        return;
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/order/save", { 'partialOrderId': this.receivable.partialOrderId }).then(function (response) {
        _this6.showMessage(response.data.message, response.data.success ? 'green' : 'red');
      }).catch(function (err) {
        _this6.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this6.getReceivable();
        _this6.confirmDialogGenerateOrder = false;
      });
    },
    cofirmCancelShoppingBag: function cofirmCancelShoppingBag(cancelShoppingBag) {
      if (cancelShoppingBag) {
        this.cancelShoppingBag();
      } else {
        this.confirmDialogCancelShoppingBag = false;
      }
    },
    cancelShoppingBag: function cancelShoppingBag() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/receivable/cancel", {
        'id': this.receivable.id,
        'partialOrderId': this.receivable.partialOrderId
      }).then(function (response) {
        _this7.showMessage(response.data.message, response.data.success ? 'green' : 'red');
      }).catch(function (err) {
        _this7.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this7.getReceivable();
        _this7.confirmDialogCancelShoppingBag = false;
      });
    },
    getDeliveryDistricts: function getDeliveryDistricts() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/secure/deliveries").then(function (response) {
        _this8.select.departments = response.data.departments;
        _this8.provinces = response.data.provinces;
        _this8.districts = response.data.districts;
        _this8.deliveryDistricts = response.data.deliveryDistricts;
      }).catch(function (err) {}).then(function () {});
    },
    getProducts: function getProducts() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/products").then(function (response) {
        _this9.select.products = response.data;
        _this9.productCopy = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
      }).catch(function (err) {}).then(function () {});
    },
    searchArticulos: function searchArticulos(e) {
      var _this10 = this;

      if (!this.searchProduct) {
        this.select.products = this.productCopy;
      }

      this.select.products = this.productCopy.filter(function (product) {
        return product.name.toLowerCase().indexOf(_this10.searchProduct.toLowerCase()) > -1;
      });
    },
    getProductColors: function getProductColors() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product/color/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this11.select.productColors = response.data;
      }).catch(function (err) {}).then(function () {});
    },
    getProductColorSizes: function getProductColorSizes() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product-color-sizes/:product_id".replace(':product_id', this.selected.product)).then(function (response) {
        _this12.productColorSizes = response.data;
      }).catch(function (err) {}).then(function () {
        if (_this12.select.productColors.length == 1 && _this12.select.productColors[0].color.name == 'NOT_COLOR') {
          _this12.selected.productColor = _this12.select.productColors[0].id;
        }
      });
    },
    validateStock: function validateStock() {
      this.partialOrderItems.forEach(function (obj) {
        amount = parseFloat(amount) + parseFloat(obj.amount);
        amount = parseFloat(amount).toFixed(2);
      });
    },
    addProduct: function addProduct() {
      var _this13 = this;

      var request = {
        'partialOrderId': this.partialOrder.id,
        'productId': this.selected.product,
        'productColorId': this.selected.productColor,
        'productColorSizeId': this.selected.productColorSize,
        'quantity': this.quantity,
        'receivableId': this.receivable.id
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/partial-order/add/product", request).then(function (response) {
        var color = response.data.success ? 'green' : 'red';
        _this13.showMessage(response.data.message, color);

        _this13.selected.product = null;
        _this13.selected.productColor = null;
        _this13.selected.productColorSize = null;
        _this13.select.productColors = [];
        _this13.select.productColorSizes = [];
        _this13.quantity = null;
        _this13.unit_price = null;
        _this13.off = null;
        _this13.productColorImageUrl = null;
        _this13.stock = null;

        _this13.findReceivableForId(_this13.receivable.id);
        _this13.getReceivable();
      }).catch(function (err) {
        if (err.response && err.response.data) {
          var apiError = Object(__WEBPACK_IMPORTED_MODULE_6__utils_error_index__["a" /* normalizeApiError */])(err.response.data);
          _this13.showMessage(apiError.message, 'red');
        } else {
          _this13.showMessage('Hubo un problema en el servidor', 'red');
        }
      });
    },
    getProductImagesForTypeAndColor: function getProductImagesForTypeAndColor() {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("secure/product/color/:product_color_id/images/:type".replace(':product_color_id', this.selected.productColor).replace(':type', 'mediano')).then(function (response) {
        var self = _this14;
        response.data.forEach(function (obj) {
          if (obj.order == 1) {
            self.productColorImageUrl = obj.image;
          }
        });
      }).catch(function (err) {});
    },
    calculeAmounts: function calculeAmounts() {
      var subtotal = this.partialOrder.subtotal ? parseFloat(this.partialOrder.subtotal) : 0;
      var shippingPrice = this.partialOrder.shipping_price ? parseFloat(this.partialOrder.shipping_price) : 0;
      var coupon = this.partialOrder.coupon ? parseFloat(this.partialOrder.coupon) : 0;
      var total = parseFloat(subtotal + shippingPrice - coupon).toFixed(2);
      var advancePayment = this.partialOrder.advance_payment ? parseFloat(this.partialOrder.advance_payment) : 0;

      this.partialOrder.total = total;
      this.partialOrder.pending_payment = parseFloat(total - advancePayment).toFixed(2);
    },


    removeRow: function removeRow(index, item) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/partial-order/detail/delete", {
        'partialOrderDetailId': item.id,
        'partialOrderId': this.partialOrder.id,
        'receivableId': this.receivable.id
      }).then(function (response) {
        var color = response.data.success ? 'green' : 'red';
        _this15.showMessage(response.data.message, color);
      }).then(function () {
        _this15.findReceivableForId(_this15.receivable.id);
        _this15.getReceivable();
      }).catch(function (err) {
        _this15.showMessage('Hubo un problema en el servidor', 'red');
      });
    },

    updateSale: function updateSale() {
      var _this16 = this;

      if (this.partialOrder.total < 0) {
        this.showMessage('Para actualizar su bolsita, el TOTAL no debe ser genativo.', 'deep-purple accent-4');
        return;
      }

      if (this.partialOrder.shipping_price === '' || this.partialOrder.shipping_price === null || isNaN(this.partialOrder.shipping_price)) {
        this.partialOrder.shipping_price = 0;
      }

      if (this.partialOrder.coupon === '' || this.partialOrder.coupon === null || isNaN(this.partialOrder.coupon)) {
        this.partialOrder.coupon = 0;
      }

      var request = {
        'client': this.client,
        'address': this.address,
        'partialOrder': this.partialOrder,
        'receivable': this.receivable,
        'partialOrderDetail': this.partialOrderItems
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/partial-order/update", request).then(function (response) {
        var color = response.data.success ? 'green' : 'red';
        _this16.showMessage(response.data.message, color);
        _this16.getReceivable();
      }).catch(function (err) {
        _this16.showMessage('Hubo un problema en el servidor', 'red');
      });
    },
    cleanAddress: function cleanAddress() {
      this.address.department_id = null;
      this.address.province_id = null;
      this.address.district_id = null;
    },
    printTicket: function printTicket(partialOrderId) {
      var _this17 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/secure/ticket", {
        'partialOrderId': partialOrderId
      }, {
        responseType: 'blob'
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this17.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this17.overlay = false;
      });
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.getReceivable();
    this.getDeliveryDistricts();
    this.getProducts();
  },

  watch: {
    dialog: function dialog(val) {
      if (val === false) {
        this.cleanReceivableSelected();
      }
    },
    shoppingBagDialog: function shoppingBagDialog(val) {
      if (val === false) {
        this.cleamShoppingBag();
      }
    },

    'address.department_id': function addressDepartment_id(val) {
      if (val) {
        var self = this;
        this.provinces.forEach(function (obj) {
          if (obj.department_id == val) {
            self.select.provinces.push(obj);
          }
        });
      }
    },
    'address.province_id': function addressProvince_id(val) {
      if (val) {
        var self = this;
        this.districts.forEach(function (obj) {
          if (obj.province_id == val) {
            self.select.districts.push(obj);
          }
        });
      }
    },
    'address.district_id': function addressDistrict_id(newDistrictId, oldDistrictId) {
      if (newDistrictId != oldDistrictId) {
        if (this.address.shipping_type_id == 1) {
          var self = this;
          this.deliveryDistricts.forEach(function (obj) {
            if (obj.district_id == newDistrictId) {
              if (obj.size == 2) {
                self.partialOrder.shipping_price = obj.price;
                var coupon = self.partialOrder.coupon > 0 ? self.partialOrder.coupon : 0;
                var total = parseFloat(self.partialOrder.subtotal) + parseFloat(obj.price) - parseFloat(coupon);
                self.partialOrder.total = parseFloat(total).toFixed(2);
              }
            }
          });
        } else if (this.address.shipping_type_id == 2) {
          this.address.address = 'Almacén Villa el Salvador\nAv. Mariano Pastor Sevilla & Av. Talara, Villa EL Salvador 15837';
        }
      }
    },
    'selected.product': function selectedProduct(val) {
      if (val) {
        var self = this;
        this.select.productColors = [];
        this.select.productColorSizes = [];
        this.select.products.forEach(function (obj) {
          if (obj.id == self.selected.product) {
            self.unit_price = obj.off > 0 ? obj.sale_price : obj.regular_price;
            self.off = obj.off;
            return;
          }
        });
        this.getProductColors();
        this.getProductColorSizes();
      }
    },
    'selected.productColor': function selectedProductColor(val) {
      if (val) {
        var self = this;

        this.select.productColorSizes = [];
        this.productColorSizes.forEach(function (obj) {
          if (obj.product_color_id == val) {
            self.select.productColorSizes.push(obj);
          }
        });

        if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
          this.selected.productColorSize = this.select.productColorSizes[0].id;
        }

        this.getProductImagesForTypeAndColor();
      }
    },
    'selected.productColorSize': function selectedProductColorSize(val) {
      if (val) {
        var self = this;
        this.productColorSizes.forEach(function (obj) {
          if (obj.id == val) {
            self.stock = obj.stock;
          }
        });
      }
    },
    'partialOrder.shipping_price': function partialOrderShipping_price(newShippingPrice, oldShippingPrice) {
      if (newShippingPrice != oldShippingPrice) {
        this.calculeAmounts();
      }
    },
    'partialOrder.coupon': function partialOrderCoupon(newCoupon, oldCoupon) {
      if (newCoupon !== oldCoupon) {
        this.calculeAmounts();
      }
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highcharts_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = "https://admin.dino-toys.com/api";

__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('es');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeliveryCalendarView',
  components: {
    DefaultLayout: __WEBPACK_IMPORTED_MODULE_1__layouts_DefaultLayout__["a" /* default */],
    highcharts: __WEBPACK_IMPORTED_MODULE_4_highcharts_vue__["Chart"]
  },
  data: function data() {
    return {
      overlay: false,
      panel: [0, 1, 2],
      date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().toISOString(true).substr(0, 10),
      modalDeliveryDay: false,
      search: {
        date: null
      },
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        '4day': '4 Días'
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['red', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      productHeaders: [{ text: 'PRODUCTO', value: 'product_name', width: '25%' }, { text: 'COLOR', value: 'color_name', width: '10%' }, { text: 'TALLA', value: 'size_name', width: '10%' }, { text: 'UNI.', value: 'quantity', width: '10%' }],
      // ************ snackbar ************
      snackbar: false,
      text: '',
      color: 'green'
      // **********************************
    };
  },

  computed: {
    dateText: function dateText() {
      this.search.date = this.date;
      return this.formatDateInit(this.date);
    }
  },
  methods: {
    formatDateInit: function formatDateInit(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    formatPending: function formatPending(value) {
      if (!isNaN(parseFloat(value)) && isFinite(value)) {
        return 'S/ ' + parseFloat(value).toFixed(2);
      }
      return value;
    },
    weekdayFormat: function weekdayFormat(_ref) {
      var weekday = _ref.weekday;

      var dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      return dias[weekday];
    },
    weekdayShortFormat: function weekdayShortFormat(_ref2) {
      var weekday = _ref2.weekday;

      var dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
      return dias[weekday];
    },
    showMessage: function showMessage(text, color) {
      this.snackbar = true;
      this.text = text;
      this.color = color;
    },
    viewDay: function viewDay(_ref3) {
      var date = _ref3.date;

      this.focus = date;
      this.type = 'day';
    },
    getEventColor: function getEventColor(event) {
      return event.color;
    },
    setToday: function setToday() {
      this.focus = '';
    },
    prev: function prev() {
      this.$refs.calendar.prev();
    },
    next: function next() {
      this.$refs.calendar.next();
    },
    showEvent: function showEvent(_ref4) {
      var _this = this;

      var nativeEvent = _ref4.nativeEvent,
          event = _ref4.event;

      var open = function open() {
        _this.selectedEvent = event;
        _this.selectedElement = nativeEvent.target;
        requestAnimationFrame(function () {
          return requestAnimationFrame(function () {
            return _this.selectedOpen = true;
          });
        });
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(function () {
          return requestAnimationFrame(function () {
            return open();
          });
        });
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange: function updateRange(_ref5) {
      var _this2 = this;

      var start = _ref5.start,
          end = _ref5.end;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/secure/deliveries/calendar", {
        params: {
          start: start.date,
          end: end.date
        }
      }).then(function (response) {
        var events = [];
        for (var i = 0; i < response.data.length; i++) {

          var clientDelivery = response.data[i];
          var color = 'grey darken-1';

          if (clientDelivery.shipping_type == 'MOTORIZADO') {
            color = 'red';
          } else if (clientDelivery.shipping_type == 'ALMACEN') {
            color = 'green';
          } else if (clientDelivery.shipping_type == 'AGENCIA') {
            color = 'deep-purple';
          } else {
            color = 'grey darken-1';
          }

          events.push({
            name: clientDelivery.shipping_type + ' - ' + clientDelivery.phone,
            start: clientDelivery.delivery_day,
            end: clientDelivery.delivery_day,
            color: color,
            timed: false,
            client_full_name: clientDelivery.client_full_name,
            address_name: clientDelivery.address_name,
            district_name: clientDelivery.district_name,
            delivery_day: _this2.formatDateInit(clientDelivery.delivery_day),
            products: clientDelivery.products,
            pending_payment: clientDelivery.pending_payment
          });
        }
        _this2.events = events;
      }).catch(function (err) {
        console.log(err);
        _this2.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this2.overlay = false;
      });
    },


    // rnd (a, b) {
    //   return Math.floor((b - a + 1) * Math.random()) + a
    // },

    domwloadLabels: function domwloadLabels() {
      var _this3 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/secure/labeled/motorized/deliveries", {
        'date': this.search.date
      }, {
        responseType: 'blob'
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this3.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this3.overlay = false;
      });
    },
    domwloadLabelsForAgency: function domwloadLabelsForAgency() {
      var _this4 = this;

      this.overlay = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/secure/labeled/agency/deliveries", {
        'date': this.search.date
      }, {
        responseType: 'blob'
      }).then(function (response) {
        var fileURL = URL.createObjectURL(response.data);
        var a = document.createElement('a');
        a.setAttribute('href', fileURL);
        a.setAttribute('download', response.headers['name-file']);
        a.click();
      }).catch(function (err) {
        _this4.showMessage('Hubo un problema en el servidor', 'red');
      }).then(function () {
        _this4.overlay = false;
      });
    },


    logout: function logout() {
      localStorage.clear();
      window.location.href = "/";
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers = {
      'authorization': localStorage.getItem('authorization')
    };

    this.$refs.calendar.checkChange();
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyDeTBbPrcpEBv0SbEKP2qQiVdsFrpPuL0U",
  authDomain: "dino-toys.firebaseapp.com",
  projectId: "dino-toys",
  storageBucket: "dino-toys.appspot.com",
  messagingSenderId: "1031185169439",
  appId: "1:1031185169439:web:60d84d5309ff9464be292a"
};

__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.initializeApp(firebaseConfig);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  vuetify: new __WEBPACK_IMPORTED_MODULE_4_vuetify___default.a({
    theme: {
      themes: {
        light: {
          primary:  true ? '#173578' : 'black',
          secondary: '#f7a501',
          accent: '#8c9eff',
          error: '#b71c1c',
          nominusClaro: '#9cb59c',
          dinotoys_orange: '#fd9724',
          dinotoys_green: '#459429',
          dinotoys_red: '#eb313e',
          adm_orange: '#f44336'
        }
      }
    }
  }),
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9a8cfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9a8cfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Inicio__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Dashboard__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_manage_Product__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_manage_OrderSupplier__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_manage_Inventory__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_manage_HomeImage__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_order_Order__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_order_OrderProfit__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_marketing_ProductsImage__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_order_Sale__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_order_Receivable__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_order_DeliveryCalendar__ = __webpack_require__(467);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */]
  }, {
    path: '/inicio',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Inicio__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Dashboard__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/manage/product',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_5__views_manage_Product__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/manage/order-supplier',
    name: 'OrderSupplier',
    component: __WEBPACK_IMPORTED_MODULE_6__views_manage_OrderSupplier__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/manage/inventory',
    name: 'Inventory',
    component: __WEBPACK_IMPORTED_MODULE_7__views_manage_Inventory__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/manage/home-image',
    name: 'HomeImage',
    component: __WEBPACK_IMPORTED_MODULE_8__views_manage_HomeImage__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/order/order',
    name: 'Order',
    component: __WEBPACK_IMPORTED_MODULE_9__views_order_Order__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/order/profit',
    name: 'Profit',
    component: __WEBPACK_IMPORTED_MODULE_10__views_order_OrderProfit__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/order/sale',
    name: 'Sale',
    component: __WEBPACK_IMPORTED_MODULE_12__views_order_Sale__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/order/receivable',
    name: 'Receivable',
    component: __WEBPACK_IMPORTED_MODULE_13__views_order_Receivable__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/marketing/products-image',
    name: 'ProductsImage',
    component: __WEBPACK_IMPORTED_MODULE_11__views_marketing_ProductsImage__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/order/delivery-calendar',
    name: 'DeliveryCalendar',
    component: __WEBPACK_IMPORTED_MODULE_14__views_order_DeliveryCalendar__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  // const currentUser = firebase.auth().currentUser;
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // if (requiresAuth && !currentUser) {
  //   next('');
  // } else if (!requiresAuth && currentUser) {
  //   next('inicio');
  // } else {
  next();
  // }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7780fcb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7780fcb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7780fcb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{attrs:{"align":"center","justify":"center"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"344","color":"rgb(255, 255, 255, 0.9)"}},[_c('v-card-title',{staticClass:"justify-center"},[_c('p',{staticClass:"text--primary text-center",staticStyle:{"font-size":"20px"}},[_vm._v("\n              DINO TOYS v1.0.0\n            ")])]),_vm._v(" "),_c('v-card-title',{staticClass:"justify-center mt-n5"},[_c('img',{attrs:{"src":__webpack_require__(73),"alt":"Dino Toys","width":"200"}})]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text--primary text-center"},[_c('p',{staticStyle:{"color":"#015d01"}},[_vm._v("\n                Bienvenido al administrador de Dino Toys, por favor iniciar sesion.\n              ")])])]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-n5"},[[_c('v-form',{ref:"form",model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},[_c('v-text-field',{attrs:{"filled":"","rules":[_vm.rules.email],"color":"primary","label":"Usuario","type":"email","outlined":"","dense":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"filled":"","rules":[_vm.rules.required],"color":"primary","label":"Passowd","type":"password","outlined":"","dense":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)]],2),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mt-n2",attrs:{"disabled":!_vm.form,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.login()}}},[_vm._v("\n              Iniciar Sesión\n            ")])],1)],1)]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b50e222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b50e222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-app-bar',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dino Toys")])],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"app":"","bottom":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('div',{staticClass:"pa-2"},[_c('v-btn',{attrs:{"block":"","dark":"","color":"primary"},on:{"click":_vm.logout}},[_vm._v("\n          Salir\n        ")])],1)]},proxy:true}]),model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-item',{staticClass:"justify-center"},[_c('v-avatar',{attrs:{"color":"red","size":"120"}},[_c('v-icon',{attrs:{"dark":"","size":"120"}},[_vm._v("\n            mdi-account-circle\n          ")])],1)],1),_vm._v(" "),_c('v-list-item',{attrs:{"link":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.usuario.names)+"\n          ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.usuario.email))]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"title",staticStyle:{"color":"#173578 !important"}},[_vm._v("Administrador")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"nav":"","dense":""}},[_c('v-list-item-group',{attrs:{"color":"primary"},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}},[_vm._l((_vm.menus),function(acceso){return [(acceso.name != '')?_c('v-subheader',[_vm._v(_vm._s(acceso.name))]):_vm._e(),_vm._v(" "),_vm._l((acceso.submenu),function(item,i){return [_c('v-list-item',{key:item.name,attrs:{"to":item.link}},[_c('v-list-item-icon',[_c('v-icon',{domProps:{"textContent":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(item.name)}})],1)],1)]})]})],2)],1)],1),_vm._v(" "),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-container',{attrs:{"fluid":""}},[_vm._t("content")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}})],1)]],2)],_vm._v(" "),[_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n            Close\n          ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n\n        ")])],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb945ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(394);
function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb945ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 113,
	"./af.js": 113,
	"./ar": 114,
	"./ar-dz": 115,
	"./ar-dz.js": 115,
	"./ar-kw": 116,
	"./ar-kw.js": 116,
	"./ar-ly": 117,
	"./ar-ly.js": 117,
	"./ar-ma": 118,
	"./ar-ma.js": 118,
	"./ar-sa": 119,
	"./ar-sa.js": 119,
	"./ar-tn": 120,
	"./ar-tn.js": 120,
	"./ar.js": 114,
	"./az": 121,
	"./az.js": 121,
	"./be": 122,
	"./be.js": 122,
	"./bg": 123,
	"./bg.js": 123,
	"./bm": 124,
	"./bm.js": 124,
	"./bn": 125,
	"./bn-bd": 126,
	"./bn-bd.js": 126,
	"./bn.js": 125,
	"./bo": 127,
	"./bo.js": 127,
	"./br": 128,
	"./br.js": 128,
	"./bs": 129,
	"./bs.js": 129,
	"./ca": 130,
	"./ca.js": 130,
	"./cs": 131,
	"./cs.js": 131,
	"./cv": 132,
	"./cv.js": 132,
	"./cy": 133,
	"./cy.js": 133,
	"./da": 134,
	"./da.js": 134,
	"./de": 135,
	"./de-at": 136,
	"./de-at.js": 136,
	"./de-ch": 137,
	"./de-ch.js": 137,
	"./de.js": 135,
	"./dv": 138,
	"./dv.js": 138,
	"./el": 139,
	"./el.js": 139,
	"./en-au": 140,
	"./en-au.js": 140,
	"./en-ca": 141,
	"./en-ca.js": 141,
	"./en-gb": 142,
	"./en-gb.js": 142,
	"./en-ie": 143,
	"./en-ie.js": 143,
	"./en-il": 144,
	"./en-il.js": 144,
	"./en-in": 145,
	"./en-in.js": 145,
	"./en-nz": 146,
	"./en-nz.js": 146,
	"./en-sg": 147,
	"./en-sg.js": 147,
	"./eo": 148,
	"./eo.js": 148,
	"./es": 149,
	"./es-do": 150,
	"./es-do.js": 150,
	"./es-mx": 151,
	"./es-mx.js": 151,
	"./es-us": 152,
	"./es-us.js": 152,
	"./es.js": 149,
	"./et": 153,
	"./et.js": 153,
	"./eu": 154,
	"./eu.js": 154,
	"./fa": 155,
	"./fa.js": 155,
	"./fi": 156,
	"./fi.js": 156,
	"./fil": 157,
	"./fil.js": 157,
	"./fo": 158,
	"./fo.js": 158,
	"./fr": 159,
	"./fr-ca": 160,
	"./fr-ca.js": 160,
	"./fr-ch": 161,
	"./fr-ch.js": 161,
	"./fr.js": 159,
	"./fy": 162,
	"./fy.js": 162,
	"./ga": 163,
	"./ga.js": 163,
	"./gd": 164,
	"./gd.js": 164,
	"./gl": 165,
	"./gl.js": 165,
	"./gom-deva": 166,
	"./gom-deva.js": 166,
	"./gom-latn": 167,
	"./gom-latn.js": 167,
	"./gu": 168,
	"./gu.js": 168,
	"./he": 169,
	"./he.js": 169,
	"./hi": 170,
	"./hi.js": 170,
	"./hr": 171,
	"./hr.js": 171,
	"./hu": 172,
	"./hu.js": 172,
	"./hy-am": 173,
	"./hy-am.js": 173,
	"./id": 174,
	"./id.js": 174,
	"./is": 175,
	"./is.js": 175,
	"./it": 176,
	"./it-ch": 177,
	"./it-ch.js": 177,
	"./it.js": 176,
	"./ja": 178,
	"./ja.js": 178,
	"./jv": 179,
	"./jv.js": 179,
	"./ka": 180,
	"./ka.js": 180,
	"./kk": 181,
	"./kk.js": 181,
	"./km": 182,
	"./km.js": 182,
	"./kn": 183,
	"./kn.js": 183,
	"./ko": 184,
	"./ko.js": 184,
	"./ku": 185,
	"./ku.js": 185,
	"./ky": 186,
	"./ky.js": 186,
	"./lb": 187,
	"./lb.js": 187,
	"./lo": 188,
	"./lo.js": 188,
	"./lt": 189,
	"./lt.js": 189,
	"./lv": 190,
	"./lv.js": 190,
	"./me": 191,
	"./me.js": 191,
	"./mi": 192,
	"./mi.js": 192,
	"./mk": 193,
	"./mk.js": 193,
	"./ml": 194,
	"./ml.js": 194,
	"./mn": 195,
	"./mn.js": 195,
	"./mr": 196,
	"./mr.js": 196,
	"./ms": 197,
	"./ms-my": 198,
	"./ms-my.js": 198,
	"./ms.js": 197,
	"./mt": 199,
	"./mt.js": 199,
	"./my": 200,
	"./my.js": 200,
	"./nb": 201,
	"./nb.js": 201,
	"./ne": 202,
	"./ne.js": 202,
	"./nl": 203,
	"./nl-be": 204,
	"./nl-be.js": 204,
	"./nl.js": 203,
	"./nn": 205,
	"./nn.js": 205,
	"./oc-lnc": 206,
	"./oc-lnc.js": 206,
	"./pa-in": 207,
	"./pa-in.js": 207,
	"./pl": 208,
	"./pl.js": 208,
	"./pt": 209,
	"./pt-br": 210,
	"./pt-br.js": 210,
	"./pt.js": 209,
	"./ro": 211,
	"./ro.js": 211,
	"./ru": 212,
	"./ru.js": 212,
	"./sd": 213,
	"./sd.js": 213,
	"./se": 214,
	"./se.js": 214,
	"./si": 215,
	"./si.js": 215,
	"./sk": 216,
	"./sk.js": 216,
	"./sl": 217,
	"./sl.js": 217,
	"./sq": 218,
	"./sq.js": 218,
	"./sr": 219,
	"./sr-cyrl": 220,
	"./sr-cyrl.js": 220,
	"./sr.js": 219,
	"./ss": 221,
	"./ss.js": 221,
	"./sv": 222,
	"./sv.js": 222,
	"./sw": 223,
	"./sw.js": 223,
	"./ta": 224,
	"./ta.js": 224,
	"./te": 225,
	"./te.js": 225,
	"./tet": 226,
	"./tet.js": 226,
	"./tg": 227,
	"./tg.js": 227,
	"./th": 228,
	"./th.js": 228,
	"./tk": 229,
	"./tk.js": 229,
	"./tl-ph": 230,
	"./tl-ph.js": 230,
	"./tlh": 231,
	"./tlh.js": 231,
	"./tr": 232,
	"./tr.js": 232,
	"./tzl": 233,
	"./tzl.js": 233,
	"./tzm": 234,
	"./tzm-latn": 235,
	"./tzm-latn.js": 235,
	"./tzm.js": 234,
	"./ug-cn": 236,
	"./ug-cn.js": 236,
	"./uk": 237,
	"./uk.js": 237,
	"./ur": 238,
	"./ur.js": 238,
	"./uz": 239,
	"./uz-latn": 240,
	"./uz-latn.js": 240,
	"./uz.js": 239,
	"./vi": 241,
	"./vi.js": 241,
	"./x-pseudo": 242,
	"./x-pseudo.js": 242,
	"./yo": 243,
	"./yo.js": 243,
	"./zh-cn": 244,
	"./zh-cn.js": 244,
	"./zh-hk": 245,
	"./zh-hk.js": 245,
	"./zh-mo": 246,
	"./zh-mo.js": 246,
	"./zh-tw": 247,
	"./zh-tw.js": 247
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("VENTAS DEL AÑO "+_vm._s(_vm.year))])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.year,"item-value":"id","item-text":"name","label":"Año","dense":"","outlined":""},on:{"change":_vm.getMonthlySales},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("VENTAS + BOLSITAS SIN CERRAR DEL AÑO "+_vm._s(_vm.year))])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.year,"item-value":"id","item-text":"name","label":"Año","dense":"","outlined":""},on:{"change":_vm.getMonthlySalesAndPartialSales},model:{value:(_vm.yearForSaleAndPartialSale),callback:function ($$v) {_vm.yearForSaleAndPartialSale=$$v},expression:"yearForSaleAndPartialSale"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('highcharts',{attrs:{"options":_vm.chartOptionsForSaleAndPartialSale}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("LOS "+_vm._s(_vm.top)+" PRODUCTOS MÁS VENDIDOS DEL AÑO")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.top,"item-value":"id","item-text":"name","label":"¿Cuantos productos desea ver?","dense":"","outlined":""},on:{"change":_vm.getBestSellingProducts},model:{value:(_vm.top),callback:function ($$v) {_vm.top=$$v},expression:"top"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('highcharts',{attrs:{"options":_vm.lineChartOptions}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v(_vm._s(_vm.topD4)+" PRODUCTOS MÁS VENDIDOS DEL "+_vm._s(_vm.monthD4)+"/"+_vm._s(_vm.yearD4))])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.top,"item-value":"id","item-text":"name","label":"¿Cuantos productos desea ver?","dense":"","outlined":""},on:{"change":_vm.bestSellingProductsPerMonth},model:{value:(_vm.topD4),callback:function ($$v) {_vm.topD4=$$v},expression:"topD4"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.month,"item-value":"id","item-text":"name","label":"Año","dense":"","outlined":""},on:{"change":_vm.bestSellingProductsPerMonth},model:{value:(_vm.monthD4),callback:function ($$v) {_vm.monthD4=$$v},expression:"monthD4"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.year,"item-value":"id","item-text":"name","label":"¿Cuantos productos desea ver?","dense":"","outlined":""},on:{"change":_vm.bestSellingProductsPerMonth},model:{value:(_vm.yearD4),callback:function ($$v) {_vm.yearD4=$$v},expression:"yearD4"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('highcharts',{attrs:{"options":_vm.chartOptionsBestSellingProductsPerMonth}})],1)],1)],1)],1)],1)],1)],1)],1)],1)]],2)],_vm._v(" "),[_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n            Close\n          ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n\n        ")])],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc2a6158_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc2a6158_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Filtrar Producto(s)")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"searchProduct",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Rango Fechas de Creación","prepend-icon":"mdi-calendar","readonly":""},model:{value:(_vm.dateRangeText),callback:function ($$v) {_vm.dateRangeText=$$v},expression:"dateRangeText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":"","range":"","locale":"es","max":_vm.date,"selected-items-text":"seleccionados"},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modal = false}}},[_vm._v("\n                                        Cancel\n                                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("\n                                        OK\n                                      ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-btn',{attrs:{"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.getProducts()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                      manage_search\n                                    ")])],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-btn',{attrs:{"color":"green","block":"","depressed":""},on:{"click":function($event){return _vm.domwloadExcel()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                      file_download\n                                    ")])],1)],1)],1)],1)],1)]],2)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Registro de Productos")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""}},[_vm._v("\n                                "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                              ")])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.showDetail(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                  mdi-pencil\n                                ")])],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Producto")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2","disabled":_vm.product.id ? false : true}},[_vm._v("Colores")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3","disabled":_vm.product.id ? false : true}},[_vm._v("Imágenes")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-4","disabled":_vm.product.id ? false : true}},[_vm._v("Tallas")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.categories,"item-value":"id","item-text":"name","label":"Categoria","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product.category_id),callback:function ($$v) {_vm.$set(_vm.product, "category_id", $$v)},expression:"product.category_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.brands,"item-value":"id","item-text":"name","label":"Marca","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product.brand_id),callback:function ($$v) {_vm.$set(_vm.product, "brand_id", $$v)},expression:"product.brand_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.groups,"item-value":"id","item-text":"name","label":"Group","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product.group),callback:function ($$v) {_vm.$set(_vm.product, "group", $$v)},expression:"product.group"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Nombre del Producto","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.product.name),callback:function ($$v) {_vm.$set(_vm.product, "name", $$v)},expression:"product.name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Precio de Venta","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.product.regular_price),callback:function ($$v) {_vm.$set(_vm.product, "regular_price", $$v)},expression:"product.regular_price"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Descuento (%)","outlined":"","dense":""},model:{value:(_vm.product.off),callback:function ($$v) {_vm.$set(_vm.product, "off", $$v)},expression:"product.off"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Precio con Descuento","outlined":"","dense":""},model:{value:(_vm.product.sale_price),callback:function ($$v) {_vm.$set(_vm.product, "sale_price", $$v)},expression:"product.sale_price"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.size_deliveries,"item-value":"id","item-text":"name","label":"Tamaño del Producto","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product.size_delivery),callback:function ($$v) {_vm.$set(_vm.product, "size_delivery", $$v)},expression:"product.size_delivery"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product.status),callback:function ($$v) {_vm.$set(_vm.product, "status", $$v)},expression:"product.status"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-textarea',{attrs:{"outlined":"","name":"input-7-4","label":"Descripcion","rows":"3"},model:{value:(_vm.product.description),callback:function ($$v) {_vm.$set(_vm.product, "description", $$v)},expression:"product.description"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.submitProduct()}}},[_vm._v("\n                                      "+_vm._s(_vm.product.id ? 'Actualizar' : 'Registrar')+"\n                                    ")])],1)],1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",attrs:{"value":"tab-2"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColor",model:{value:(_vm.validProductColor),callback:function ($$v) {_vm.validProductColor=$$v},expression:"validProductColor"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.colors,"item-value":"id","item-text":"name","label":"Color","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color.color_id),callback:function ($$v) {_vm.$set(_vm.product_color, "color_id", $$v)},expression:"product_color.color_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color.status),callback:function ($$v) {_vm.$set(_vm.product_color, "status", $$v)},expression:"product_color.status"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColor,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.submitProductColor()}}},[_vm._v("\n                                      "+_vm._s(_vm.product_color.id ? 'Actualizar' : 'Registrar')+"\n                                    ")])],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.PCHeaders,"items":_vm.PCItems},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""}},[_vm._v("\n                                      "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                                    ")])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.showDetailProductColor(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                        mdi-pencil\n                                      ")])],1)]}}])})],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"3",attrs:{"value":"tab-3"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColorImage",model:{value:(_vm.validProductColorImage),callback:function ($$v) {_vm.validProductColorImage=$$v},expression:"validProductColorImage"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.PCItems,"item-value":"id","item-text":"color.name","label":"Color","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color_image.product_color_id),callback:function ($$v) {_vm.$set(_vm.product_color_image, "product_color_id", $$v)},expression:"product_color_image.product_color_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color_image.status),callback:function ($$v) {_vm.$set(_vm.product_color_image, "status", $$v)},expression:"product_color_image.status"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColorImage || _vm.imagesTmp.length == 0,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveProductColorImages()}}},[_vm._v("\n                                      Registrar\n                                    ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-file-input',{attrs:{"counter":"","label":"Seleccionar Imágenes","multiple":"","show-size":1000,"rules":[_vm.rules.required],"dense":"","outlined":""},on:{"change":_vm.imagesSelected},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"color":"deep-purple accent-4","dark":"","label":"","small":""}},[_vm._v("\n                                          "+_vm._s(text)+"\n                                        ")])]}}]),model:{value:(_vm.imagesTmp),callback:function ($$v) {_vm.imagesTmp=$$v},expression:"imagesTmp"}})],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-expansion-panels',{attrs:{"popout":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.PCIItems),function(pcii,i){return _c('v-expansion-panel',{key:i,attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{style:({'background-color':pcii.color.hexcolor}),attrs:{"text":"circle"}})],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v(_vm._s(pcii.color.name))]),_vm._v(" "),(pcii.product_color_image)?_c('span',{staticClass:"grey--text"},[_vm._v("\n                                             ("+_vm._s(pcii.product_color_image.length)+")\n                                          ")]):_vm._e()]),_vm._v(" "),_c('v-col',{staticClass:"text-no-wrap",attrs:{"cols":"5","sm":"3"}},[_c('v-chip',{staticClass:"ml-0 mr-2 black--text",attrs:{"color":_vm.getColorOrTextStatus(pcii.status, 'color'),"label":"","small":""}},[_vm._v("\n                                            "+_vm._s(_vm.getColorOrTextStatus(pcii.status, 'text'))+"\n                                          ")])],1),_vm._v(" "),_c('v-col',{staticClass:"grey--text text-truncate hidden-sm-and-down"},[_vm._v("\n                                          —\n                                          Hacer clic para ver detalle de imágenes\n                                        ")])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-container',[_vm._l((_vm.imagesRefactor),function(color){return [_c('draggable',{staticClass:"row",on:{"change":function($event){color.update_position = true}},model:{value:(color.images),callback:function ($$v) {_vm.$set(color, "images", $$v)},expression:"color.images"}},[(pcii.color_id == color.color_id)?[_vm._l((color.images),function(img,index){return [_c('v-col',{key:img.id,staticClass:".image",attrs:{"cols":"12","md":"3","sm":"6"}},[_c('v-card',{staticClass:"mt-2 mb-2 image",attrs:{"color":"grey lighten-4","flat":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","color":"transparent"}},[_c('v-chip',{staticClass:"ml-0 mr-2 white--text",attrs:{"color":"red","label":"","small":""}},[_c('b',[_vm._v("# "+_vm._s(index + 1))])])],1),_vm._v(" "),_c('v-img',{attrs:{"src":img.image,"height":"50%"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)})],1)],1)]})]:_vm._e()],2),_vm._v(" "),(pcii.color_id == color.color_id)?_c('v-card-actions',[_c('v-btn',{staticClass:"mt-n2",attrs:{"disabled":!color.update_position,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.updateOrderImg(color)}}},[_vm._v("\n                                              Actualizar Orden\n                                            ")])],1):_vm._e()]})],2)],1)],1)}),1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"4",attrs:{"value":"tab-4"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColorSize",model:{value:(_vm.validProductColorSize),callback:function ($$v) {_vm.validProductColorSize=$$v},expression:"validProductColorSize"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.PCItems,"item-value":"id","item-text":"color.name","label":"Color","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color_size.product_color_id),callback:function ($$v) {_vm.$set(_vm.product_color_size, "product_color_id", $$v)},expression:"product_color_size.product_color_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.sizes,"item-value":"id","item-text":"name","label":"Talla","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color_size.size_id),callback:function ($$v) {_vm.$set(_vm.product_color_size, "size_id", $$v)},expression:"product_color_size.size_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Stock","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.product_color_size.stock),callback:function ($$v) {_vm.$set(_vm.product_color_size, "stock", $$v)},expression:"product_color_size.stock"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.product_color_size.status),callback:function ($$v) {_vm.$set(_vm.product_color_size, "status", $$v)},expression:"product_color_size.status"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColorSize,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.submitProductColorSize()}}},[_vm._v("\n                                      "+_vm._s(_vm.product_color_size.id ? 'Actualizar' : 'Registrar')+"\n                                    ")])],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.PCSHeaders,"items":_vm.PCSItems},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""}},[_vm._v("\n                                      "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                                    ")])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.showDetailProductColorSize(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                        mdi-pencil\n                                      ")])],1)]}}])})],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                    Cerrar\n                  ")])],1)],1)],1)],1)],_vm._v(" "),_c('div',{staticStyle:{"position":"fixed","bottom":"16px","right":"16px","display":"flex","flex-direction":"column","gap":"12px","z-index":"9999"}},[_c('v-btn',{attrs:{"fab":"","bottom":"","color":"primary","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("mdi-plus")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"fab":"","bottom":"","color":"green","dark":""},on:{"click":function($event){return _vm.domwloadExcel()}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-file-excel")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Descargar Stock")])])],1)],2)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSupplier_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2694a786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSupplier_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSupplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2694a786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSupplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Registro de Productos")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                              "+_vm._s(_vm.formatDateTime(item.created_at))+"\n                            ")]}},{key:"item.delivery_day",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                              "+_vm._s(_vm.formatDate(item.delivery_day))+"\n                            ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""}},[_vm._v("\n                                "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                              ")])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.getDetail(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                    visibility\n                                  ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.copy(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                    content_copy\n                                  ")])],1)],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Pedidos de Productos (Proveedor)")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"form",attrs:{"disabled":_vm.orderSupplier.id ? true : false},model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-expansion-panels',{attrs:{"popout":"","multiple":""},model:{value:(_vm.panelOrder),callback:function ($$v) {_vm.panelOrder=$$v},expression:"panelOrder"}},[_c('v-expansion-panel',{key:"orderSupplier",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("storefront")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DATOS DE LA COMPRA")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"label":"Nombre del Proveedor","outlined":"","dense":""},model:{value:(_vm.orderSupplier.supplier_name),callback:function ($$v) {_vm.$set(_vm.orderSupplier, "supplier_name", $$v)},expression:"orderSupplier.supplier_name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Entrega o Recojo","readonly":"","outlined":"","dense":""},model:{value:(_vm.dateText),callback:function ($$v) {_vm.dateText=$$v},expression:"dateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalDeliveryDay),callback:function ($$v) {_vm.modalDeliveryDay=$$v},expression:"modalDeliveryDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalDeliveryDay = false}}},[_vm._v("\n                                                      Cancel\n                                                    ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("\n                                                      OK\n                                                    ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-text-field',{attrs:{"label":"Cantidad de Productos Pedidos","outlined":"","dense":"","disabled":""},model:{value:(_vm.orderSupplier.quantity),callback:function ($$v) {_vm.$set(_vm.orderSupplier, "quantity", $$v)},expression:"orderSupplier.quantity"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"addProduct",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("AGREGAR PRODUCTOS AL DETALLE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-select',{attrs:{"items":_vm.select.products,"item-value":"id","item-text":"name","label":"Productos","rules":[_vm.rules.required],"dense":"","outlined":""},scopedSlots:_vm._u([{key:"prepend-item",fn:function(){return [_c('v-list-item',[_c('v-list-item-content',[_c('v-text-field',{attrs:{"placeholder":"Buscar","dense":"","outlined":""},on:{"input":_vm.searchArticulos},model:{value:(_vm.searchProduct),callback:function ($$v) {_vm.searchProduct=$$v},expression:"searchProduct"}})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.selected.product),callback:function ($$v) {_vm.$set(_vm.selected, "product", $$v)},expression:"selected.product"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-select',{attrs:{"items":_vm.select.productColors,"item-value":"id","item-text":"color.name","label":"Colores","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.selected.productColor),callback:function ($$v) {_vm.$set(_vm.selected, "productColor", $$v)},expression:"selected.productColor"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-select',{attrs:{"items":_vm.select.productColorSizes,"item-value":"id","item-text":"size.name","label":"Tallas","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.selected.productColorSize),callback:function ($$v) {_vm.$set(_vm.selected, "productColorSize", $$v)},expression:"selected.productColorSize"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-text-field',{attrs:{"label":"Cantidad","outlined":"","dense":""},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-text-field',{attrs:{"label":"Precio Unitario","outlined":"","dense":""},model:{value:(_vm.unit_price),callback:function ($$v) {_vm.unit_price=$$v},expression:"unit_price"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[(!_vm.orderSupplier.id)?_c('v-btn',{attrs:{"readonly":!_vm.valid,"color":"primary","block":"","depressed":""},on:{"click":_vm.addProduct}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-plus")])],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"orderSupplierDetail",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DETALLE DE COMPRA")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.OSHeaders,"items":_vm.OSItems},scopedSlots:_vm._u([{key:"item.accion",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary","disabled":_vm.orderSupplier.id ? true : false},on:{"click":function($event){return _vm.removeRow(index, item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                                        delete\n                                                      ")])],1)]}}])})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Costo del Recojo o Delivery","outlined":"","dense":""},model:{value:(_vm.orderSupplier.shipping_price),callback:function ($$v) {_vm.$set(_vm.orderSupplier, "shipping_price", $$v)},expression:"orderSupplier.shipping_price"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Subtotal","outlined":"","dense":"","disabled":""},model:{value:(_vm.orderSupplier.subtotal),callback:function ($$v) {_vm.$set(_vm.orderSupplier, "subtotal", $$v)},expression:"orderSupplier.subtotal"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Total","outlined":"","dense":"","disabled":""},model:{value:(_vm.orderSupplier.total),callback:function ($$v) {_vm.$set(_vm.orderSupplier, "total", $$v)},expression:"orderSupplier.total"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.orderSupplier.id)?[_c('v-col',{attrs:{"cols":"12","md":"4","offset-md":"8"}},[_c('v-btn',{attrs:{"disabled":_vm.disabledBtnSave,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveOrderSupplier()}}},[_vm._v("\n                                        REGISTRAR COMPRA\n                                      ")])],1)]:[_c('v-col',{attrs:{"cols":"12","md":"2","offset-md":"8"}},[_c('v-btn',{staticStyle:{"color":"white"},attrs:{"color":"red","block":"","depressed":"","disabled":_vm.orderSupplier.status == 2 || _vm.orderSupplier.status == 0},on:{"click":function($event){return _vm.updateStatusOrderSupplier(_vm.orderSupplier.id, 0)}}},[_vm._v("\n                                        ANULAR\n                                      ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-btn',{staticStyle:{"color":"white"},attrs:{"color":"green","block":"","depressed":"","disabled":_vm.orderSupplier.status == 2 || _vm.orderSupplier.status == 0},on:{"click":function($event){return _vm.updateStatusOrderSupplier(_vm.orderSupplier.id, 2)}}},[_vm._v("\n                                        RECEPCIONADO\n                                      ")])],1)]],2)],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                    Cerrar\n                  ")])],1)],1)],1)],1)],_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","right":"","color":"primary","dark":"","fixed":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],2)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bbf90dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bbf90dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Inventario de Productos")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-class":_vm.stockCeroBackground},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                              "+_vm._s(_vm.formatDate(item.created_at))+"\n                            ")]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","right":"","color":"green","dark":"","fixed":""},on:{"click":function($event){return _vm.domwloadExcel()}}},[_c('v-icon',[_vm._v("description")])],1)],2)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeImage_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602d6532_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeImage_vue__ = __webpack_require__(449);
function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602d6532_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('v-alert',{attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v("\n                          Para visualizar las imágenes de tipo celular, ingresar desde el mismo dispositivo.\n                        ")])],1)])],_vm._v(" "),[(_vm.$vuetify.breakpoint.xsOnly)?[_c('v-carousel',{attrs:{"cycle":true,"height":"auto"}},[_vm._l((_vm.items),function(item,i){return [(item.type == 100 && item.status == 1)?[_c('v-carousel-item',{key:i},[_c('v-img',{attrs:{"src":item.image}})],1)]:_vm._e()]})],2)]:[_c('v-carousel',{attrs:{"cycle":true,"height":"auto","type":"card"}},[_vm._l((_vm.items),function(item,i){return [(item.type == 1 && item.status == 1)?[_c('v-carousel-item',{key:i,attrs:{"eager":""}},[_c('v-img',{attrs:{"max-height":"700px","eager":"","src":item.image}})],1)]:_vm._e()]})],2)],_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pt-8",attrs:{"cols":"12","lg":"8","md":"10","sm":"12","xs":"12"}},[_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[(_vm.$vuetify.breakpoint.xsOnly)?[_vm._l((_vm.bodyList),function(body){return [(body.status == 1 && body.type == 100)?[_c('v-col',{staticClass:"pt-8",attrs:{"cols":"12","md":"12"}},[_c('v-card',{staticClass:"pa-2 rounded",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0","height":"100%"}},[_c('v-img',{attrs:{"eager":"","src":body.image}})],1)],1)]:_vm._e()]})]:[_vm._l((_vm.bodyList),function(body){return [(body.status == 1 && body.type == 1)?[_c('v-col',{staticClass:"pt-8",attrs:{"cols":"12","md":"12"}},[_c('v-card',{staticClass:"pa-2 rounded",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0","height":"100%"}},[_c('v-img',{attrs:{"eager":"","src":body.image}})],1)],1)]:_vm._e()]})]],2)],1)],1)],1),_vm._v(" "),_vm._l((_vm.footerList),function(groupRow){return [_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","sm":"12","xs":"12"}},[_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[[_c('v-card',{staticClass:"elevation-10",attrs:{"color":"primary","dark":""}},[_c('v-card-title',{staticClass:"text-h6 pa-2 ma-2"},[_c('b',{attrs:{"color":"primary"}},[_vm._v(_vm._s(groupRow.title))])])],1)]],2)],1),_vm._v(" "),_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8","align":"center","justify":"center"}},[_c('v-slide-group',{attrs:{"multiple":"","show-arrows":"always"}},[_c('v-row',{staticClass:"my-1",attrs:{"justify":"center","align":"center"}},_vm._l((groupRow.list),function(body){return (body.status == 1)?_c('v-slide-item',{key:body.id,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-card',{staticClass:"ma-3",attrs:{"color":active ? undefined : 'grey lighten-1',"height":"300","width":"250","min-width":"250"},on:{"click":toggle}},[_c('v-img',{attrs:{"eager":"","src":body.image}})],1)]}}],null,true)}):_vm._e()}),1)],1)],1)],1)],1)],1)],1)]})]],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Imágenes Cabecera")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("Imágenes Cuerpo")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3"}},[_vm._v("Imágenes Pies")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColorImage",model:{value:(_vm.validProductColorImage),callback:function ($$v) {_vm.validProductColorImage=$$v},expression:"validProductColorImage"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.groups,"item-value":"id","item-text":"name","label":"Group","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.banner.group),callback:function ($$v) {_vm.$set(_vm.banner, "group", $$v)},expression:"banner.group"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.type,"item-value":"id","item-text":"name","label":"Tipo","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.banner.type),callback:function ($$v) {_vm.$set(_vm.banner, "type", $$v)},expression:"banner.type"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.banner.status),callback:function ($$v) {_vm.$set(_vm.banner, "status", $$v)},expression:"banner.status"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-file-input',{attrs:{"counter":"","label":"Seleccionar Imágenes","multiple":"","show-size":1000,"rules":[_vm.rules.required],"dense":"","outlined":""},on:{"change":function($event){return _vm.imagesSelected(1)}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"color":"deep-purple accent-4","dark":"","label":"","small":""}},[_vm._v("\n                                          "+_vm._s(text)+"\n                                        ")])]}}]),model:{value:(_vm.imagesTmp),callback:function ($$v) {_vm.imagesTmp=$$v},expression:"imagesTmp"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColorImage || _vm.imagesTmp.length == 0,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveBanners()}}},[_vm._v("\n                                      Registrar\n                                    ")])],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.bannerHeader,"items":_vm.items},scopedSlots:_vm._u([{key:"item.showImage",fn:function(ref){
var item = ref.item;
return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-img',{attrs:{"src":item.image,"width":"70"}})],1)]}},{key:"item.type",fn:function(ref){
var item = ref.item;
return [(item.type == 1)?[_vm._v("MONITOR")]:[_vm._v("CELULAR")]]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""},on:{"click":function($event){return _vm.updateStatus(1, item)}}},[_vm._v("\n                                      "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                                    ")])]}}])})],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",attrs:{"value":"tab-2"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColorImage",model:{value:(_vm.validProductColorImage),callback:function ($$v) {_vm.validProductColorImage=$$v},expression:"validProductColorImage"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.groups,"item-value":"id","item-text":"name","label":"Group","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.bannerBody.group),callback:function ($$v) {_vm.$set(_vm.bannerBody, "group", $$v)},expression:"bannerBody.group"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.type,"item-value":"id","item-text":"name","label":"Tipo","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.bannerBody.type),callback:function ($$v) {_vm.$set(_vm.bannerBody, "type", $$v)},expression:"bannerBody.type"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.bannerBody.status),callback:function ($$v) {_vm.$set(_vm.bannerBody, "status", $$v)},expression:"bannerBody.status"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-file-input',{attrs:{"counter":"","label":"Seleccionar Imágenes","multiple":"","show-size":1000,"rules":[_vm.rules.required],"dense":"","outlined":""},on:{"change":function($event){return _vm.imagesSelected(2)}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"color":"deep-purple accent-4","dark":"","label":"","small":""}},[_vm._v("\n                                          "+_vm._s(text)+"\n                                        ")])]}}]),model:{value:(_vm.imagesTmpBody),callback:function ($$v) {_vm.imagesTmpBody=$$v},expression:"imagesTmpBody"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColorImage || _vm.imagesTmpBody.length == 0,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveBannersBody()}}},[_vm._v("\n                                      Registrar\n                                    ")])],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.bannerBodyHeader,"items":_vm.bodyList},scopedSlots:_vm._u([{key:"item.showImage",fn:function(ref){
var item = ref.item;
return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-img',{attrs:{"src":item.image,"width":"70"}})],1)]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""},on:{"click":function($event){return _vm.updateStatus(2, item)}}},[_vm._v("\n                                      "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                                    ")])]}}])})],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"3",attrs:{"value":"tab-3"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColorImage",model:{value:(_vm.validProductColorImage),callback:function ($$v) {_vm.validProductColorImage=$$v},expression:"validProductColorImage"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.products,"item-value":"name","item-text":"name","label":"Productos","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.bannerFooter.group),callback:function ($$v) {_vm.$set(_vm.bannerFooter, "group", $$v)},expression:"bannerFooter.group"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Título","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.bannerFooter.title),callback:function ($$v) {_vm.$set(_vm.bannerFooter, "title", $$v)},expression:"bannerFooter.title"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Grupo de Imágenes","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.bannerFooter.group_row),callback:function ($$v) {_vm.$set(_vm.bannerFooter, "group_row", $$v)},expression:"bannerFooter.group_row"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","rules":[_vm.rules.required],"dense":"","outlined":""},model:{value:(_vm.bannerFooter.status),callback:function ($$v) {_vm.$set(_vm.bannerFooter, "status", $$v)},expression:"bannerFooter.status"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-file-input',{attrs:{"counter":"","label":"Seleccionar Imágenes","multiple":"","show-size":1000,"rules":[_vm.rules.required],"dense":"","outlined":""},on:{"change":function($event){return _vm.imagesSelected(3)}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"color":"deep-purple accent-4","dark":"","label":"","small":""}},[_vm._v("\n                                          "+_vm._s(text)+"\n                                        ")])]}}]),model:{value:(_vm.imagesTmpFooter),callback:function ($$v) {_vm.imagesTmpFooter=$$v},expression:"imagesTmpFooter"}})],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validProductColorImage || _vm.imagesTmpFooter.length == 0,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveBannersFooter()}}},[_vm._v("\n                                      Registrar\n                                    ")])],1)],1)],1)],1)],_vm._v(" "),[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.bannerFooterHeader,"items":_vm.allRowFooter},scopedSlots:_vm._u([{key:"item.showImage",fn:function(ref){
var item = ref.item;
return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-img',{attrs:{"src":item.image,"width":"70"}})],1)]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""},on:{"click":function($event){return _vm.updateStatus(3, item)}}},[_vm._v("\n                                      "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                                    ")])]}}])})],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                    Cerrar\n                  ")])],1)],1)],1)],1)],_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","right":"","color":"primary","dark":"","fixed":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],2)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0e29b9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__(452);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0e29b9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Registro de Compras")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([{key:"header.orderNumber",fn:function(ref){
var header = ref.header;
return [_vm._v("\n                              NÚMERO PEDIDO"),_c('br'),_vm._v("[PEDIDO ID - CLIENT ID]\n                            ")]}},{key:"item.orderNumber",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"small":"","color":"orange","dark":""}},[_vm._v("\n                                "+_vm._s(item.orderNumber)+"\n                              ")])]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"x-small":"","color":_vm.getColorOrTextStatus(item.status, 'color'),"dark":""}},[_vm._v("\n                                "+_vm._s(_vm.getColorOrTextStatus(item.status, 'text'))+"\n                              ")])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.getDetail(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                  mdi-pencil\n                                ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"accent"},on:{"click":function($event){return _vm.getLabel(item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                  delivery_dining\n                                ")])],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Datos de la Orden y Cliente")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2","readonly":_vm.order.id ? false : true}},[_vm._v("Detalle de la Orden")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-expansion-panels',{attrs:{"popout":"","multiple":""},model:{value:(_vm.panelOrder),callback:function ($$v) {_vm.panelOrder=$$v},expression:"panelOrder"}},[_c('v-expansion-panel',{key:"order",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("storefront")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DATOS DE LA ORDEN")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Fecha de Pedido","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.created_at),callback:function ($$v) {_vm.$set(_vm.order, "created_at", $$v)},expression:"order.created_at"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Cantidad de Productos","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.quantity),callback:function ($$v) {_vm.$set(_vm.order, "quantity", $$v)},expression:"order.quantity"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Tipo de Envío","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.shipping_type_id),callback:function ($$v) {_vm.$set(_vm.order, "shipping_type_id", $$v)},expression:"order.shipping_type_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Total Delivery","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.shipping_price),callback:function ($$v) {_vm.$set(_vm.order, "shipping_price", $$v)},expression:"order.shipping_price"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Subtotal","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.subtotal),callback:function ($$v) {_vm.$set(_vm.order, "subtotal", $$v)},expression:"order.subtotal"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Cupón","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.coupon),callback:function ($$v) {_vm.$set(_vm.order, "coupon", $$v)},expression:"order.coupon"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Total","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.total),callback:function ($$v) {_vm.$set(_vm.order, "total", $$v)},expression:"order.total"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Fecha de Delivery","outlined":"","dense":"","readonly":""},model:{value:(_vm.order.delivery_day),callback:function ($$v) {_vm.$set(_vm.order, "delivery_day", $$v)},expression:"order.delivery_day"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Delivery Partner","outlined":"","dense":""},model:{value:(_vm.order.delivery_partner),callback:function ($$v) {_vm.$set(_vm.order, "delivery_partner", $$v)},expression:"order.delivery_partner"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.updateDeliveryPartner()}}},[_vm._v("\n                                                  ACTUALIZAR PARTNER\n                                                ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"client",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("contact_mail")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("INFORMACIÓN DEL CLIENTE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-text-field',{attrs:{"label":"Nombre y Apellidos","outlined":"","dense":"","readonly":""},model:{value:(_vm.client.names),callback:function ($$v) {_vm.$set(_vm.client, "names", $$v)},expression:"client.names"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-text-field',{attrs:{"label":"Número de Celular","outlined":"","dense":"","readonly":""},model:{value:(_vm.client.phone),callback:function ($$v) {_vm.$set(_vm.client, "phone", $$v)},expression:"client.phone"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"7"}},[_c('v-text-field',{attrs:{"label":"Email","outlined":"","dense":"","readonly":""},model:{value:(_vm.client.email),callback:function ($$v) {_vm.$set(_vm.client, "email", $$v)},expression:"client.email"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"address",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DIRECCIÓN DEL CLIENTE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-text-field',{attrs:{"label":"Dirección","outlined":"","dense":"","readonly":""},model:{value:(_vm.address.address),callback:function ($$v) {_vm.$set(_vm.address, "address", $$v)},expression:"address.address"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-text-field',{attrs:{"label":"Referencia","outlined":"","dense":"","readonly":""},model:{value:(_vm.address.reference),callback:function ($$v) {_vm.$set(_vm.address, "reference", $$v)},expression:"address.reference"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4","offset-md":"8"}},[_c('v-btn',{attrs:{"readonly":!_vm.valid,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.updateStatusOrder(_vm.order.id, _vm.order.status)}}},[_vm._v("\n                                      "+_vm._s(_vm.order.status == 1 ? 'ANULAR' : 'REVERTIR ANULACIÓN')+"\n                                    ")])],1)],1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",attrs:{"value":"tab-2"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.ODHeaders,"items":_vm.ODItems}})],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                    Cerrar\n                  ")])],1)],1)],1)],1)]],2)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialogLabel),callback:function ($$v) {_vm.dialogLabel=$$v},expression:"dialogLabel"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"}),_vm._v(" "),_c('v-card-text',[_c('v-row',{staticClass:"mt-1"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","outlined":"","name":"input-7-4","label":"Descripcion","value":_vm.labelDetail,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialogLabel = false}}},[_vm._v("\n                Cerrar\n              ")])],1)],1)],1)],1)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProfit_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb085bc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProfit_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProfit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb085bc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProfit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[[_c('div',[_c('v-alert',{attrs:{"color":"#ce3479c7","dark":"","icon":"campaign","border":"right"}},[_vm._v("\n                    Aún quedan REGISTRO DE COMPRA(s) por cerrar. "),_c('br'),_vm._v("\n                    Número de registros faltante por cerrar a la Fecha de Hoy "+_vm._s(_vm.getNowDate())+" es de "),_c('b',[_vm._v(_vm._s(_vm.numberUnclosedOrders))])])],1)]],2),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("GANANCIA DE VENTAS REALIZADAS")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                              "+_vm._s(_vm.formatDate(item.created_at))+"\n                            ")]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","right":"","color":"green","dark":"","fixed":""},on:{"click":function($event){return _vm.domwloadExcel()}}},[_c('v-icon',[_vm._v("description")])],1)],2)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsImage_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a3e2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsImage_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7a3e2a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a3e2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mt-8"},[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","xs":"12"}},[_c('v-select',{attrs:{"items":_vm.select.groups,"item-value":"id","item-text":"name","label":"Group","dense":"","outlined":""},model:{value:(_vm.groupSelected),callback:function ($$v) {_vm.groupSelected=$$v},expression:"groupSelected"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"6","xs":"12"}},[_c('v-select',{attrs:{"items":_vm.select.filters,"item-value":"id","item-text":"name","label":"Ordenar por:","dense":"","outlined":""},on:{"change":_vm.findProduct},model:{value:(_vm.orderBy),callback:function ($$v) {_vm.orderBy=$$v},expression:"orderBy"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"6","md":"3","sm":"6","xs":"6"}},[_c('v-checkbox',{attrs:{"label":"¿Desea visualizar el % de descuento en las imágenes generadas?"},model:{value:(_vm.displayProductOff),callback:function ($$v) {_vm.displayProductOff=$$v},expression:"displayProductOff"}})],1)],1)],1)],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"8","md":"12","xs":"12"}},[_c('v-row',[_vm._l((_vm.shownCards),function(item,index){return [_c('v-col',{key:item.id,ref:item.id,refInFor:true,attrs:{"cols":"12","lg":"3","md":"4","sm":"6","xs":"12"}},[_c('v-card',{staticStyle:{"border":"5px solid #1b74e4"},attrs:{"outlined":"","elevation":"0"}},[_c('img',{key:item.product_color_image[0].image,staticStyle:{"width":"100%"},attrs:{"min-height":_vm.$vuetify.breakpoint.xsOnly ? 250 : 180,"src":item.product_color_image[0].image}}),_vm._v(" "),_c('v-card-title',{staticClass:"justify-center mt-n2"},[_c('span',{staticClass:"input-group-product"},[_vm._v("\n                      "+_vm._s(item.product.group)+"\n                    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-row',{staticClass:"mx-0",attrs:{"align":"center"}},[_c('v-rating',{attrs:{"value":item.product.average_star ? item.product.average_star : 5,"color":"secondary","dense":"","half-increments":"","readonly":"","size":"16"}})],1),_vm._v(" "),_c('div',{staticClass:"my-3 product-name"},[_c('span',{staticClass:"input-name-product",on:{"click":function($event){return _vm.productImageSelected(item)}}},[_vm._v("\n                        "+_vm._s(item.product.name)+"\n                      ")])])],1),_vm._v(" "),_c('v-card-title',{staticClass:"mt-n10"},[_c('v-row',{attrs:{"no-gutters":""}},[(item.product.off)?[_c('v-col',{attrs:{"cols":"3","sm":"4","xs":"4"}},[_c('v-card',{staticClass:"pa-0 ma-0 text-left",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_c('img',{attrs:{"src":__webpack_require__(73),"alt":"Dino Toys","width":"45"}})])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9","sm":"8","xs":"8"}},[_c('v-card',{staticClass:"pa-0 ma-0 text-right conetnido",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[(_vm.displayProductOff)?_c('v-chip',{attrs:{"color":"pink","label":"","text-color":"white"}},[_vm._v("\n                              - "+_vm._s(item.product.off)+"%\n                            ")]):_vm._e(),_vm._v("\n                            S/ "+_vm._s(item.product.sale_price)+"\n                          ")],1),_vm._v(" "),_c('v-card',{staticClass:"pa-0 ma-0 body-2 text-right",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_vm._v("\n                            S/ "+_vm._s(item.product.regular_price)+"\n                          ")])],1)]:[_c('v-col',{attrs:{"cols":"6","sm":"4","xs":"4"}},[_c('v-card',{staticClass:"pa-0 ma-0 text-left",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_c('img',{attrs:{"src":__webpack_require__(73),"alt":"Dino Toys","width":"45"}})])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"8","xs":"8"}},[_c('v-card',{staticClass:"pa-0 ma-0 text-right",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_vm._v("\n                            S/ "+_vm._s(item.product.regular_price)+"\n                          ")]),_vm._v(" "),_c('v-card',{staticClass:"pa-0 ma-0 body-2 text-right",staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_vm._v("\n                             \n                          ")])],1)]],2)],1)],1)],1)]})],2),_vm._v(" "),_c('v-row',{staticClass:"pt-8 pb-8",attrs:{"justify":"center"}},[_c('v-pagination',{attrs:{"length":_vm.length},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1),_vm._v(" "),_c('v-row',[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"12"}},[_c('v-btn',{attrs:{"disabled":_vm.disabledSubmit,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.generateImages()}}},[_vm._v("\n                Generar Imagenes\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"timeout":"7000","color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sale_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9810168_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sale_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sale_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9810168_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DATOS DEL CLIENTE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"searchProductForm"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"label":"Nombre / Apellido / DNI o CE / # Celular","rules":[_vm.rules.required],"outlined":"","dense":""},on:{"input":_vm.onInputFindClient,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchClient()}},model:{value:(_vm.findClient),callback:function ($$v) {_vm.findClient=$$v},expression:"findClient"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-btn',{attrs:{"disabled":_vm.findClient ? false : true,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.searchClient()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                      manage_search\n                                    ")])],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2","offset-md":"2"}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Apertura","readonly":"","outlined":"","dense":""},model:{value:(_vm.dateText),callback:function ($$v) {_vm.dateText=$$v},expression:"dateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalDeliveryDay),callback:function ($$v) {_vm.modalDeliveryDay=$$v},expression:"modalDeliveryDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalDeliveryDay = false}}},[_vm._v("\n                                        Cancel\n                                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("\n                                        OK\n                                      ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Nombre","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.client.name),callback:function ($$v) {_vm.$set(_vm.client, "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Apellido","outlined":"","dense":"","required":""},model:{value:(_vm.client.last_name),callback:function ($$v) {_vm.$set(_vm.client, "last_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.last_name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"DNI/CE","outlined":"","dense":"","required":""},model:{value:(_vm.client.identification_doc),callback:function ($$v) {_vm.$set(_vm.client, "identification_doc", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.identification_doc"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Celular","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},on:{"input":function($event){_vm.client.phone = _vm.client.phone.replace(/\s+/g, '')}},model:{value:(_vm.client.phone),callback:function ($$v) {_vm.$set(_vm.client, "phone", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.phone"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.deliveryTypes,"item-value":"id","item-text":"name","label":"Tipo de Entrega","dense":"","outlined":"","clearable":""},model:{value:(_vm.address.shipping_type_id),callback:function ($$v) {_vm.$set(_vm.address, "shipping_type_id", $$v)},expression:"address.shipping_type_id"}})],1),_vm._v(" "),(_vm.address.shipping_type_id == 1 || _vm.address.shipping_type_id == 2)?[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.departments : _vm.filteredDepartments,"item-value":"id","item-text":"name","label":"Departamento","dense":"","outlined":""},model:{value:(_vm.address.department_id),callback:function ($$v) {_vm.$set(_vm.address, "department_id", $$v)},expression:"address.department_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.provinces : _vm.filteredProvinces,"item-value":"id","item-text":"name","label":"Provincia","dense":"","outlined":""},model:{value:(_vm.address.province_id),callback:function ($$v) {_vm.$set(_vm.address, "province_id", $$v)},expression:"address.province_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.districts : _vm.filteredDistricts,"item-value":"id","item-text":"name","label":"Distrito","dense":"","outlined":""},model:{value:(_vm.address.district_id),callback:function ($$v) {_vm.$set(_vm.address, "district_id", $$v)},expression:"address.district_id"}})],1)]:_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-text-field',{attrs:{"label":"Dirección","outlined":"","dense":"","required":""},model:{value:(_vm.address.address),callback:function ($$v) {_vm.$set(_vm.address, "address", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"address.address"}})],1)],2)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"addProduct",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("AGREGAR PRODUCTOS AL DETALLE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-select',{attrs:{"items":_vm.select.products,"item-value":"id","item-text":"name","label":"Productos","dense":"","outlined":""},scopedSlots:_vm._u([{key:"prepend-item",fn:function(){return [_c('v-list-item',[_c('v-list-item-content',[_c('v-text-field',{attrs:{"placeholder":"Buscar","dense":"","outlined":""},on:{"input":_vm.searchArticulos},model:{value:(_vm.searchProduct),callback:function ($$v) {_vm.searchProduct=$$v},expression:"searchProduct"}})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.selected.product),callback:function ($$v) {_vm.$set(_vm.selected, "product", $$v)},expression:"selected.product"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-select',{attrs:{"items":_vm.select.productColors,"item-value":"id","item-text":"color.name","label":"Colores","dense":"","outlined":""},model:{value:(_vm.selected.productColor),callback:function ($$v) {_vm.$set(_vm.selected, "productColor", $$v)},expression:"selected.productColor"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-select',{attrs:{"items":_vm.select.productColorSizes,"item-value":"id","item-text":"size.name","label":"Tallas","dense":"","outlined":""},model:{value:(_vm.selected.productColorSize),callback:function ($$v) {_vm.$set(_vm.selected, "productColorSize", $$v)},expression:"selected.productColorSize"}})],1),_vm._v(" "),_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","md":"2"}},[_c('v-text-field',{attrs:{"label":"Stock","background-color":_vm.stock && _vm.stock > 0 ? 'green' : 'red',"outlined":"","dense":"","disabled":""},model:{value:(_vm.stock),callback:function ($$v) {_vm.stock=$$v},expression:"stock"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":("Precio Unitario " + ((_vm.off ? _vm.off + '% dsc' : ''))),"value":_vm.unit_price,"disabled":"","outlined":"","dense":""}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Cantidad","type":"number","min":"0","step":"1","outlined":"","dense":"","rules":[
                                          function (v) { return Number.isInteger(v) || 'Solo se permiten números enteros'; },
                                          function (v) { return v >= 0 || 'El monto debe ser mayor o igual a 0'; }
                                        ]},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=_vm._n($$v)},expression:"quantity"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":(!_vm.quantity || _vm.quantity <= 0) || _vm.stock <= 0,"color":"primary","block":"","depressed":""},on:{"click":_vm.addProduct}},[_vm._v("\n                                        AGREGAR PRODUCTO\n                                      ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4","xs":"12"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',{staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_c('v-img',{key:_vm.productColorImageUrl,attrs:{"src":_vm.productColorImageUrl,"height":"auto"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary lighten-5"}})],1)]},proxy:true}])},[_vm._v(" "),(_vm.off)?[_c('div',{staticClass:"text-right"},[_c('v-chip',{staticClass:"ma-0 short",attrs:{"color":"pink","label":"","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n                                                  mdi-label\n                                                ")]),_vm._v(" "),_c('b',{staticClass:"body-2"},[_vm._v("- "+_vm._s(_vm.off)+"%")])],1)],1)]:_vm._e()],2)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"partialOderDetail",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("assistant_direction")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DETALLE DE VENTA")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.partialOrderHeaders,"items":_vm.partialOrderItems},scopedSlots:_vm._u([{key:"item.accion",fn:function(ref){
                                        var item = ref.item;
                                        var index = ref.index;
return [_c('v-btn',{attrs:{"depressed":"","color":"primary","disabled":_vm.partialOrder.id ? true : false},on:{"click":function($event){return _vm.removeRow(index, item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                      delete\n                                    ")])],1)]}}])})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Subtotal","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.subtotal),callback:function ($$v) {_vm.$set(_vm.partialOrder, "subtotal", $$v)},expression:"partialOrder.subtotal"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Costo de Entrega","type":"number","outlined":"","dense":""},model:{value:(_vm.partialOrder.shipping_price),callback:function ($$v) {_vm.$set(_vm.partialOrder, "shipping_price", $$v)},expression:"partialOrder.shipping_price"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Dsc Cupón (-)","type":"number","outlined":"","dense":""},model:{value:(_vm.partialOrder.coupon),callback:function ($$v) {_vm.$set(_vm.partialOrder, "coupon", $$v)},expression:"partialOrder.coupon"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Total","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.total),callback:function ($$v) {_vm.$set(_vm.partialOrder, "total", $$v)},expression:"partialOrder.total"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Adelanto (-)","type":"number","outlined":"","dense":""},model:{value:(_vm.partialOrder.advance_payment),callback:function ($$v) {_vm.$set(_vm.partialOrder, "advance_payment", $$v)},expression:"partialOrder.advance_payment"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Pendiente","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.pending_payment),callback:function ($$v) {_vm.$set(_vm.partialOrder, "pending_payment", $$v)},expression:"partialOrder.pending_payment"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4","offset-md":"8"}},[_c('v-btn',{attrs:{"disabled":_vm.partialOrderItems.length == 0 ? true : false,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.saveSale()}}},[_vm._v("\n                  REGISTRAR VENTA\n                ")])],1)],1)],1)]],2)],_vm._v(" "),[_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialogClients),callback:function ($$v) {_vm.dialogClients=$$v},expression:"dialogClients"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Clientes encontrados")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"form",model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Filtrar datos de la tabla","single-line":"","hide-details":""},model:{value:(_vm.searchClientTable),callback:function ($$v) {_vm.searchClientTable=$$v},expression:"searchClientTable"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.searchClientTable,"expanded":_vm.expanded,"show-expand":""},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"expanded-item",fn:function(ref){
                                        var headers = ref.headers;
                                        var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[[_c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('v-radio-group',{model:{value:(_vm.radioGroup),callback:function ($$v) {_vm.radioGroup=$$v},expression:"radioGroup"}},_vm._l((item.address),function(data){return _c('v-radio',{key:data.id,attrs:{"label":((data.shipping_type) + ": " + (data.address)),"value":data}})}),1)],1)]],2)]}},{key:"item.actions",fn:function(ref){
                                        var item = ref.item;
return [_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.selectdClient(item)}}},[_vm._v("\n                                      SELECCIONAR\n                                    ")])],1)]}}])})],1)],1)],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialogClients = false}}},[_vm._v("\n              Cerrar\n            ")])],1)],1)],1)],_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
                                        var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Receivable_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e416ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Receivable_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Receivable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e416ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Receivable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeApiError; });
var normalizeApiError = function normalizeApiError(errorResponse) {
   return {
      'status': errorResponse.httpStatus || errorResponse.statusCode || 500,
      'code': errorResponse.errorCode || errorResponse.code || 'UNKNOWN_ERROR',
      'message': errorResponse.errorMessage || errorResponse.message || 'Error desconocido'
   };
};

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("Filtrar bolsitas")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"searchProduct",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',{attrs:{"cols":"12","md":"12"}},[_c('v-col',[_c('v-checkbox',{attrs:{"label":"¿Mostrar Ordenes Generadas?"},model:{value:(_vm.filter.showCreatedOrders),callback:function ($$v) {_vm.$set(_vm.filter, "showCreatedOrders", $$v)},expression:"filter.showCreatedOrders"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-select',{attrs:{"items":_vm.select.status,"item-value":"id","item-text":"name","label":"Estado","disabled":_vm.filter.showCreatedOrders,"clearable":"","dense":"","outlined":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('v-btn',{attrs:{"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.getReceivable()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                          manage_search\n                                        ")])],1)],1)],1)],1)],1)]],2)],1)],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Ingresar texto a buscar","single-line":"","hide-details":""},on:{"input":_vm.onInputFindClient},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [(item.status == 0)?[_c('v-btn',{attrs:{"color":"error","dark":""}},[(!!item.orderId)?[_vm._v("\n                                    ANULADO"),_c('br'),_vm._v("N° orden "+_vm._s(item.orderId)+"\n                                  ")]:[_vm._v("\n                                    BOLSITA"),_c('br'),_vm._v("LIBERADA\n                                  ")]],2)]:_vm._e()]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-row',{staticClass:"spacer",attrs:{"align":"center","dense":""}},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){_vm.findReceivableForId(item.id); _vm.shoppingBagDialog = true}}},[_vm._v("\n                                  MODIFICAR BOLSITA\n                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){_vm.findReceivableForId(item.id); _vm.dialog = true}}},[_vm._v("\n                                  PAGOS\n                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"success","disabled":!!item.orderId || item.status == 0},on:{"click":function($event){_vm.findReceivableForId(item.id); _vm.confirmDialogGenerateOrder = true}}},[_vm._v("\n                                  GENERAR ORDEN\n                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"error","disabled":!!item.orderId || item.status == 0},on:{"click":function($event){_vm.findReceivableForId(item.id); _vm.confirmDialogCancelShoppingBag = true}}},[_vm._v("\n                                  LIBERAR BOLSITA\n                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"purple","disabled":item.status == 0},on:{"click":function($event){return _vm.printTicket(item.partialOrderId)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("\n                                    print\n                                  ")])],1)],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1)]],2)],_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Detalle de Pagos")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formPayment",model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Total","outlined":"","dense":"","disabled":""},model:{value:(_vm.receivable.total),callback:function ($$v) {_vm.$set(_vm.receivable, "total", $$v)},expression:"receivable.total"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Adelanto","outlined":"","dense":"","disabled":""},model:{value:(_vm.receivable.advancePayment),callback:function ($$v) {_vm.$set(_vm.receivable, "advancePayment", $$v)},expression:"receivable.advancePayment"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Pendiente","outlined":"","dense":"","disabled":""},model:{value:(_vm.receivable.pendingPayment),callback:function ($$v) {_vm.$set(_vm.receivable, "pendingPayment", $$v)},expression:"receivable.pendingPayment"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Ingresar monto a pagar","rules":[_vm.rules.required],"outlined":"","dense":""},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Registro","readonly":"","outlined":"","dense":""},model:{value:(_vm.dateText),callback:function ($$v) {_vm.dateText=$$v},expression:"dateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalPaymentDay),callback:function ($$v) {_vm.modalPaymentDay=$$v},expression:"modalPaymentDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalPaymentDay = false}}},[_vm._v("\n                                  Cancel\n                                ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("\n                                  OK\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-col',{staticClass:"text-right",attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":!_vm.validForm || !!_vm.receivable.orderId || _vm.receivable.status == 0,"color":"primary","block":"","depressed":""},on:{"click":_vm.savePartialPayment}},[_vm._v("\n                              REGISTRAR PAGO\n                            ")])],1)],1),_vm._v(" "),_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","sm":"10"}},[_c('v-data-table',{attrs:{"headers":_vm.receivableDetailHeaders,"items":_vm.receivableDetailItems},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","color":"primary","disabled":!!_vm.receivable.orderId || _vm.receivable.status == 0},on:{"click":function($event){return _vm.selectedPaymentToDelete(item)}}},[_vm._v("\n                                    ELIMINAR\n                                  ")])],1)]}}])})],1)],1)],1)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n            Cerrar\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lg":""},model:{value:(_vm.shoppingBagDialog),callback:function ($$v) {_vm.shoppingBagDialog=$$v},expression:"shoppingBagDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary dark"},[[_c('v-tabs',{attrs:{"background-color":"primary","dark":""},model:{value:(_vm.shoppingBagTab),callback:function ($$v) {_vm.shoppingBagTab=$$v},expression:"shoppingBagTab"}},[_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("Detalle de Bolsita")])],1)]],2),_vm._v(" "),_c('v-card-text',[_c('v-tabs-items',{model:{value:(_vm.shoppingBagTab),callback:function ($$v) {_vm.shoppingBagTab=$$v},expression:"shoppingBagTab"}},[_c('v-tab-item',{key:"2",attrs:{"value":"tab-2"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"formProductColor"},[_c('v-container',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("person")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DATOS DEL CLIENTE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"searchProductForm"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-dialog',{ref:"modalDeliveryDayRef",attrs:{"return-value":_vm.deliveryDate,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.deliveryDate=$event},"update:return-value":function($event){_vm.deliveryDate=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Entrega","readonly":"","outlined":"","dense":""},model:{value:(_vm.deliveryDateText),callback:function ($$v) {_vm.deliveryDateText=$$v},expression:"deliveryDateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalDeliveryDay),callback:function ($$v) {_vm.modalDeliveryDay=$$v},expression:"modalDeliveryDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.deliveryDate),callback:function ($$v) {_vm.deliveryDate=$$v},expression:"deliveryDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalDeliveryDay = false}}},[_vm._v("\n                                                        Cancel\n                                                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.modalDeliveryDayRef.save(_vm.deliveryDate)}}},[_vm._v("\n                                                        OK\n                                                      ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3","offset-md":"6"}},[_c('v-dialog',{ref:"modalRegistrationDayRef",attrs:{"return-value":_vm.registrationDate,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.registrationDate=$event},"update:return-value":function($event){_vm.registrationDate=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Apertura","readonly":"","outlined":"","dense":""},model:{value:(_vm.registrationDateText),callback:function ($$v) {_vm.registrationDateText=$$v},expression:"registrationDateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalRegistrationDay),callback:function ($$v) {_vm.modalRegistrationDay=$$v},expression:"modalRegistrationDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.registrationDate),callback:function ($$v) {_vm.registrationDate=$$v},expression:"registrationDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalRegistrationDay = false}}},[_vm._v("\n                                                        Cancel\n                                                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.modalRegistrationDayRef.save(_vm.registrationDate)}}},[_vm._v("\n                                                        OK\n                                                      ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Nombre","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.client.name),callback:function ($$v) {_vm.$set(_vm.client, "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Apellido","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.client.last_name),callback:function ($$v) {_vm.$set(_vm.client, "last_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.last_name"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"DNI/CE","outlined":"","dense":"","required":""},model:{value:(_vm.client.identification_doc),callback:function ($$v) {_vm.$set(_vm.client, "identification_doc", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.identification_doc"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-text-field',{attrs:{"label":"Celular","rules":[_vm.rules.required],"outlined":"","dense":"","required":""},model:{value:(_vm.client.phone),callback:function ($$v) {_vm.$set(_vm.client, "phone", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"client.phone"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.select.deliveryTypes,"item-value":"id","item-text":"name","label":"Tipo de Entrega","dense":"","outlined":"","clearable":""},model:{value:(_vm.address.shipping_type_id),callback:function ($$v) {_vm.$set(_vm.address, "shipping_type_id", $$v)},expression:"address.shipping_type_id"}})],1),_vm._v(" "),(_vm.address.shipping_type_id == 1 || _vm.address.shipping_type_id == 2)?[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.departments : _vm.filteredDepartments,"item-value":"id","item-text":"name","label":"Departamento","dense":"","outlined":"","clearable":""},model:{value:(_vm.address.department_id),callback:function ($$v) {_vm.$set(_vm.address, "department_id", $$v)},expression:"address.department_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.provinces : _vm.filteredProvinces,"item-value":"id","item-text":"name","label":"Provincia","dense":"","outlined":"","clearable":""},model:{value:(_vm.address.province_id),callback:function ($$v) {_vm.$set(_vm.address, "province_id", $$v)},expression:"address.province_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.address.shipping_type_id == 1 ? _vm.select.districts : _vm.filteredDistricts,"item-value":"id","item-text":"name","label":"Distrito","dense":"","outlined":"","clearable":""},model:{value:(_vm.address.district_id),callback:function ($$v) {_vm.$set(_vm.address, "district_id", $$v)},expression:"address.district_id"}})],1)]:_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-text-field',{attrs:{"label":"Dirección","outlined":"","dense":"","required":""},model:{value:(_vm.address.address),callback:function ($$v) {_vm.$set(_vm.address, "address", $$v)},expression:"address.address"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4","offset-md":"8"}},[_c('v-btn',{attrs:{"disabled":(_vm.partialOrderItems.length == 0 ? true : false) || !!_vm.receivable.orderId || _vm.receivable.status == 0,"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.updateSale()}}},[_vm._v("\n                                                    ACTUALIZAR TIPO DE ENTREGA\n                                                  ")])],1)],2)],1)],1)]],2)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"addProduct",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("add_shopping_cart")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("AGREGAR PRODUCTOS AL DETALLE")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-select',{attrs:{"items":_vm.select.products,"item-value":"id","item-text":"name","label":"Productos","dense":"","outlined":""},scopedSlots:_vm._u([{key:"prepend-item",fn:function(){return [_c('v-list-item',[_c('v-list-item-content',[_c('v-text-field',{attrs:{"placeholder":"Buscar","dense":"","outlined":""},on:{"input":_vm.searchArticulos},model:{value:(_vm.searchProduct),callback:function ($$v) {_vm.searchProduct=$$v},expression:"searchProduct"}})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.selected.product),callback:function ($$v) {_vm.$set(_vm.selected, "product", $$v)},expression:"selected.product"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-select',{attrs:{"items":_vm.select.productColors,"item-value":"id","item-text":"color.name","label":"Colores","dense":"","outlined":""},model:{value:(_vm.selected.productColor),callback:function ($$v) {_vm.$set(_vm.selected, "productColor", $$v)},expression:"selected.productColor"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-select',{attrs:{"items":_vm.select.productColorSizes,"item-value":"id","item-text":"size.name","label":"Tallas","dense":"","outlined":""},model:{value:(_vm.selected.productColorSize),callback:function ($$v) {_vm.$set(_vm.selected, "productColorSize", $$v)},expression:"selected.productColorSize"}})],1),_vm._v(" "),_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","md":"2"}},[_c('v-text-field',{attrs:{"label":"Stock","background-color":_vm.stock && _vm.stock > 0 ? 'green' : 'red',"outlined":"","dense":"","disabled":""},model:{value:(_vm.stock),callback:function ($$v) {_vm.stock=$$v},expression:"stock"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":("Precio Unitario " + ((_vm.off ? _vm.off + '% dsc' : ''))),"value":_vm.unit_price,"disabled":"","outlined":"","dense":""}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":"Cantidad","type":"number","outlined":"","dense":""},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-btn',{attrs:{"disabled":(!_vm.quantity || _vm.quantity <= 0) || _vm.stock <= 0 || !!_vm.receivable.orderId,"color":"primary","block":"","depressed":""},on:{"click":_vm.addProduct}},[_vm._v("\n                                                      AGREGAR PRODUCTO\n                                                    ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4","xs":"12"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',{staticStyle:{"border":"0"},attrs:{"outlined":"","elevation":"0"}},[_c('v-img',{key:_vm.productColorImageUrl,attrs:{"src":_vm.productColorImageUrl,"height":"auto"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary lighten-5"}})],1)]},proxy:true}])},[_vm._v(" "),(_vm.off)?[_c('div',{staticClass:"text-right"},[_c('v-chip',{staticClass:"ma-0 short",attrs:{"color":"pink","label":"","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n                                                                mdi-label\n                                                              ")]),_vm._v(" "),_c('b',{staticClass:"body-2"},[_vm._v("- "+_vm._s(_vm.off)+"%")])],1)],1)]:_vm._e()],2)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{key:"partialOrderDetail",attrs:{"hide-actions":""}},[_c('v-expansion-panel-header',[_c('v-row',{staticClass:"spacer",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"4","sm":"2","md":"1"}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"hidden-xs-only",attrs:{"sm":"5","md":"3"}},[_c('strong',[_vm._v("DETALLE DE VENTA")])])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.partialOrderHeaders,"items":_vm.partialOrderItems},scopedSlots:_vm._u([{key:"item.accion",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-btn',{attrs:{"disabled":!!_vm.receivable.orderId || _vm.receivable.status == 0,"depressed":"","color":"primary"},on:{"click":function($event){return _vm.removeRow(index, item)}}},[_vm._v("\n                                                  QUITAR PRODUCTO\n                                                ")])]}}])})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Subtotal","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.subtotal),callback:function ($$v) {_vm.$set(_vm.partialOrder, "subtotal", $$v)},expression:"partialOrder.subtotal"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Costo de Entrega","outlined":"","dense":""},model:{value:(_vm.partialOrder.shipping_price),callback:function ($$v) {_vm.$set(_vm.partialOrder, "shipping_price", $$v)},expression:"partialOrder.shipping_price"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Dsc Cupón (-)","outlined":"","dense":""},model:{value:(_vm.partialOrder.coupon),callback:function ($$v) {_vm.$set(_vm.partialOrder, "coupon", $$v)},expression:"partialOrder.coupon"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Total","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.total),callback:function ($$v) {_vm.$set(_vm.partialOrder, "total", $$v)},expression:"partialOrder.total"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Adelanto (-)","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.advance_payment),callback:function ($$v) {_vm.$set(_vm.partialOrder, "advance_payment", $$v)},expression:"partialOrder.advance_payment"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mt-n10",attrs:{"cols":"12","md":"3","offset-md":"9"}},[_c('v-text-field',{attrs:{"label":"Pendiente","outlined":"","dense":"","disabled":""},model:{value:(_vm.partialOrder.pending_payment),callback:function ($$v) {_vm.$set(_vm.partialOrder, "pending_payment", $$v)},expression:"partialOrder.pending_payment"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)]],2)],1)]],2)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"adm_orange","text":""},on:{"click":function($event){_vm.shoppingBagDialog = false}}},[_vm._v("\n            Cerrar\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.confirmDialogDelete),callback:function ($$v) {_vm.confirmDialogDelete=$$v},expression:"confirmDialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          Desea eliminar este pago realizado?\n        ")]),_vm._v(" "),_c('v-card-text',[_vm._v("Al eliminar este pago realizado, se realizará nuevamente el cálculo del monto pagado y del monto pendiente.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"error"},on:{"click":function($event){return _vm.cofirmDeletion(false)}}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.cofirmDeletion(true)}}},[_vm._v("\n            Eliminar\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.confirmDialogGenerateOrder),callback:function ($$v) {_vm.confirmDialogGenerateOrder=$$v},expression:"confirmDialogGenerateOrder"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          ¿Desea generar la orden de compra para esta bolsita aperturada?\n        ")]),_vm._v(" "),_c('v-card-text',[(this.receivable.pendingPayment == 0 || this.receivable.pendingPayment == null)?[_vm._v("\n            Esta bolsita no cuenta con saldo pendiente. ¿Desea generar su orden de compra?\n          ")]:[_vm._v("\n            Esta bolsita tiene un saldo pendiente de "+_vm._s(this.receivable.pendingPayment)+". ¿Desea generar su orden de compra de todas maneras?\n          ")]],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"error"},on:{"click":function($event){return _vm.cofirmGenerateOrder(false)}}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.cofirmGenerateOrder(true)}}},[_vm._v("\n            Generar Orden\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.confirmDialogCancelShoppingBag),callback:function ($$v) {_vm.confirmDialogCancelShoppingBag=$$v},expression:"confirmDialogCancelShoppingBag"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          ¿Desea anular la bolsita aperturada?\n        ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          Al anular esta bolsita ya no se podrá generar su orden de compra y el stock de los productos de esta bolsita se repondran al inventario.\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"error"},on:{"click":function($event){return _vm.cofirmCancelShoppingBag(false)}}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.cofirmCancelShoppingBag(true)}}},[_vm._v("\n            Anular Bolsita\n          ")])],1)],1)],1),_vm._v(" "),[_c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"color":_vm.color,"top":"","z-index":"500"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              X\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          "+_vm._s(_vm.text)+"\n          ")])],1)],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryCalendar_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cf8c6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryCalendar_vue__ = __webpack_require__(469);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63cf8c6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cf8c6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('section',{attrs:{"slot":"content"},slot:"content"},[[_c('div',[[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","xs":"12"}},[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"tile"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('b',[_vm._v("CALENDARIO DE ENTREGAS")])])],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-form',{ref:"searchProduct"},[_c('v-container',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Fecha de Apertura","readonly":"","outlined":"","dense":""},model:{value:(_vm.dateText),callback:function ($$v) {_vm.dateText=$$v},expression:"dateText"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.modalDeliveryDay),callback:function ($$v) {_vm.modalDeliveryDay=$$v},expression:"modalDeliveryDay"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.modalDeliveryDay = false}}},[_vm._v("\n                                            Cancel\n                                          ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("\n                                            OK\n                                          ")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","color":"red"},on:{"click":function($event){return _vm.domwloadLabels()}}},[_vm._v("\n                                        ROTULADO MOTORIZADO\n                                      ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","color":"deep-purple"},on:{"click":function($event){return _vm.domwloadLabelsForAgency()}}},[_vm._v("\n                                        ROTULADO AGENCIA\n                                      ")])],1)],1)],1)],1)]],2)],1)],1)],1),_vm._v(" "),_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[[_c('v-row',{staticClass:"fill-height"},[_c('v-col',[_c('v-sheet',{attrs:{"height":"64"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{staticClass:"mr-4",attrs:{"outlined":"","color":"grey darken-2"},on:{"click":_vm.setToday}},[_vm._v("\n                                        HOY\n                                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","text":"","small":"","color":"grey darken-2"},on:{"click":_vm.prev}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n                                          mdi-chevron-left\n                                        ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","text":"","small":"","color":"grey darken-2"},on:{"click":_vm.next}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n                                          mdi-chevron-right\n                                        ")])],1),_vm._v(" "),(_vm.$refs.calendar)?_c('v-toolbar-title',[_vm._v("\n                                        "+_vm._s(_vm.$refs.calendar.title)+"\n                                      ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"outlined":"","color":"grey darken-2"}},'v-btn',attrs,false),on),[_c('span',[_vm._v(_vm._s(_vm.typeToLabel[_vm.type]))]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("\n                                              mdi-menu-down\n                                            ")])],1)]}}])},[_vm._v(" "),_c('v-list',[_c('v-list-item',{on:{"click":function($event){_vm.type = 'day'}}},[_c('v-list-item-title',[_vm._v("Día")])],1),_vm._v(" "),_c('v-list-item',{on:{"click":function($event){_vm.type = 'week'}}},[_c('v-list-item-title',[_vm._v("Semana")])],1),_vm._v(" "),_c('v-list-item',{on:{"click":function($event){_vm.type = 'month'}}},[_c('v-list-item-title',[_vm._v("Mes")])],1),_vm._v(" "),_c('v-list-item',{on:{"click":function($event){_vm.type = '4day'}}},[_c('v-list-item-title',[_vm._v("4 días")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-sheet',{attrs:{"height":"1000"}},[_c('v-calendar',{ref:"calendar",attrs:{"color":"primary","events":_vm.events,"event-color":_vm.getEventColor,"type":_vm.type,"weekday-format":_vm.weekdayFormat,"weekday-short-format":_vm.weekdayShortFormat},on:{"click:event":_vm.showEvent,"click:more":_vm.viewDay,"click:date":_vm.viewDay,"change":_vm.updateRange},model:{value:(_vm.focus),callback:function ($$v) {_vm.focus=$$v},expression:"focus"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"activator":_vm.selectedElement,"offset-x":""},model:{value:(_vm.selectedOpen),callback:function ($$v) {_vm.selectedOpen=$$v},expression:"selectedOpen"}},[_c('v-card',{attrs:{"scrollable":"","flat":""}},[_c('v-toolbar',{attrs:{"color":_vm.selectedEvent.color,"dark":""}},[_c('v-toolbar-title',[_vm._v("\n                                            "+_vm._s(_vm.selectedEvent.name)+" "+_vm._s(_vm.selectedEvent.phone)+"\n                                          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.selectedOpen = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-sheet',{staticClass:"pa-3 text-center",attrs:{"color":"grey lighten-3"}},[_c('v-chip',{staticClass:"font-weight-bold",attrs:{"large":"","color":_vm.selectedEvent.status_color || 'grey darken-1',"dark":""}},[_vm._v("\n                                            "+_vm._s(_vm.selectedEvent.status_name || 'PROGRAMADO')+"\n                                          ")])],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{staticClass:"py-2"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("mdi-account")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.selectedEvent.client_full_name))])],1),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("mdi-map-marker")]),_vm._v("\n                                                "+_vm._s(_vm.selectedEvent.district_name
                                                  ? _vm.selectedEvent.address_name + ' - ' + _vm.selectedEvent.district_name
                                                  : _vm.selectedEvent.address_name)+"\n                                              ")],1),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("mdi-calendar")]),_vm._v("\n                                                Entrega: "+_vm._s(_vm.selectedEvent.delivery_day)+"\n                                              ")],1),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("\n                                                  mdi-alert-circle-outline\n                                                ")]),_vm._v("\n                                                Pendiente: "+_vm._s(_vm.formatPending(_vm.selectedEvent.pending_payment))+"\n                                              ")],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","color":"blue darken-2"},on:{"click":function($event){return _vm.domwloadLabels()}}},[_vm._v("\n                                                  Marcar EN RUTA\n                                                ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","color":"green darken-1"},on:{"click":function($event){return _vm.domwloadLabelsForAgency()}}},[_vm._v("\n                                                  Marcar ENTREGADO\n                                                ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","depressed":"","color":"orange darken-1"},on:{"click":function($event){return _vm.domwloadLabelsForAgency()}}},[_vm._v("\n                                                  Marcar NO ENTREGADO\n                                                ")])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-4"}),_vm._v(" "),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"subtitle-1 font-weight-bold mb-2"},[_vm._v("\n                                                  Productos del pedido\n                                                ")]),_vm._v(" "),_c('v-data-table',{attrs:{"dense":"","headers":_vm.productHeaders,"items":_vm.selectedEvent.products}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"grey darken-2 white--text justify-center"},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-information")]),_vm._v("\n                                          Estado actual: "+_vm._s(_vm.selectedEvent.status_name || 'PROGRAMADO')+"\n                                        ")],1)],1)],1)],1)],1)],1)]],2)],1)],1)],1)],1)],1)],1)],1)],1)]],2)],_vm._v(" "),[_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
                                                  var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n            Close\n          ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n\n        ")])],_vm._v(" "),[_c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.3711510.png";

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultLayout_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d200ab94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultLayout_vue__ = __webpack_require__(387);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d200ab94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[275]);


// WEBPACK FOOTER //
// static/js/app.d213a04b48b5caa06a4d.js